
import React, { useEffect, useState } from 'react';
import AppConst from "../apis/appconst";
import axios from "axios";
import AddPayModel from '../models/AddPayModel';
import SampleModel from '../models/SampleModel';
import { Modal, Button, Form } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import Swal from "sweetalert2";
import { THEME, drawOutline, evaluateFlag, evaluateFlagSmart, genderRangeDisplay,
         makeQr, makeBarcode, loadThemeConfig, getAgeDisplay } from './reportTheme';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { loadFontAsBase64 } from "../loadFont";

import QRCode from 'qrcode';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import DataTable from 'react-data-table-component';


const LabRegistrations = () => {
  // today's date in YYYY-MM-DD for <input type="date">
  const today = new Date().toISOString().split("T")[0];

  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();

// Refund states
const [showRefundModal, setShowRefundModal] = useState(false);
const [refundAmount, setRefundAmount] = useState('');
const [refundMode, setRefundMode] = useState('');
const [refundRemarks, setRefundRemarks] = useState('');
const [refundedBy, setRefundedBy] = useState('');
const [refundHistory, setRefundHistory] = useState([]);
const [refundProcessing, setRefundProcessing] = useState(false);
const [labRefundMap, setLabRefundMap] = useState({});
const [doctors, setDoctors] = useState([]);
const [isDoctorLogin, setIsDoctorLogin] = useState(false);
const [loggedDoctorId, setLoggedDoctorId] = useState('');

useEffect(() => {
  const stored = sessionStorage.getItem("ldata");
  if (stored) {
    const parsed = JSON.parse(stored);
    setLdata(parsed);
    if (parsed.role_id === 1 || parsed.role_id === "1") {
      setIsAdmin(true);
    }
    // ✅ Doctor login → they only see their own referred patients
    if ((parsed.type || '').toString().toLowerCase() === 'doctor') {
      setIsDoctorLogin(true);
      setLoggedDoctorId(String(parsed.user_id || ''));
    }
  }
}, []);

  const [selectedUserForPrint, setSelectedUserForPrint] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [image, setImage] = useState('');
  const [watermarkImage, setWatermarkImage] = useState('');
  const [footerImage, setFooterImage] = useState('');
  const [Name, setName] = useState('');
  const [dropdownOpenIndex, setDropdownOpenIndex] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [selectedTests, setSelectedTests] = useState([]);
  const [reportMode, setReportMode] = useState("All");
  const [headerType, setHeaderType] = useState("Without Header");
  const [currentTests, setCurrentTests] = useState([]);
  const [resetTriggered, setResetTriggered] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewItem, setViewItem] = useState(null);
  const [searchKey, setSearchKey] = useState('');
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);
  // new states for totals modal
  const [showTotalsModal, setShowTotalsModal] = useState(false);
  const [totalsModalType, setTotalsModalType] = useState(''); // 'total'|'discount'|'paid'|'due'
  const [totalsModalList, setTotalsModalList] = useState([]);
// Put this with your other useState declarations near the top
const [showFooterModal, setShowFooterModal] = useState(false);
const [footerModalRows, setFooterModalRows] = useState([]);
const [footerModalTitle, setFooterModalTitle] = useState('');
// ---------- Helper: getTitleForRow ----------
// Add these state variables after your existing useState declarations
const [showPaymentModal, setShowPaymentModal] = useState(false);
const [paymentMode, setPaymentMode] = useState('Cash');
const [paymentAmount, setPaymentAmount] = useState('');
const [paymentReceivedBy, setPaymentReceivedBy] = useState('');
const [paymentRemarks, setPaymentRemarks] = useState('');
const [paymentHistory, setPaymentHistory] = useState([]);
const [selectedPaymentPatient, setSelectedPaymentPatient] = useState(null);

// Add these after your existing useState declarations

const [selectAllTests, setSelectAllTests] = useState(false);

// ---------- Helper: ensureTitleOnPatient ----------
const ensureTitleOnPatient = (p = {}) => {
  if (!p) return p;
  if (p.lab_reg_name_title && String(p.lab_reg_name_title).trim() !== '') return p;
  return { ...p, lab_reg_name_title: getTitleForRow(p) };
};

  // Inject CSS once for hover behavior (safe in useEffect)
  useEffect(() => {
    const css = `
      /* Hide action buttons by default */
      
     
      /* Make view button small & inline */
      .row-actions .btn { margin-right: 6px; }
    `;
    const style = document.createElement('style');
    style.setAttribute('data-from', 'lab-registrations-hover');
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);
// prefer explicit title, otherwise try gender-based fallback, otherwise ''
const getTitleForRow = (row) => {
  if (!row) return '';
  const t = (row.lab_reg_name_title || row.title || '').toString().trim();
  if (t) return t;
  const g = (row.lab_reg_gender || '').toString().trim().toLowerCase();
  if (g === 'male' || g === 'm') return 'Mr';
  if (g === 'female' || g === 'f') return 'Ms';
  return '';
};

// Add payment history fetcher
const fetchPaymentHistory = async (labRegId) => {
  if (!labRegId) return;
  
  try {
      const fd = new FormData();
      fd.append('lab_reg_id', labRegId);
      
      const response = await axios.post(
          AppConst.BASE_URL + AppConst.getPaymentHistoryUrl,
          fd,
          { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      
      if (response.data.status) {
          setPaymentHistory(response.data.records || []);
      }
  } catch (error) {
      console.error("Error fetching payment history:", error);
  }
};

// Add payment handler
// Replace the existing handleAddPayment function with this updated version
// Add this CSS to your useEffect
useEffect(() => {
  const css = `
    /* Hide action buttons by default */
    .row-actions .btn { margin-right: 6px; }
    
    /* ✅ SweetAlert2 on top of payment modal */
    .swal2-container.swal2-payment-modal {
      z-index: 99999 !important;
    }
  `;
  const style = document.createElement('style');
  style.setAttribute('data-from', 'lab-registrations-hover');
  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);
  return () => {
    document.head.removeChild(style);
  };
}, []);

// Update handleAddPayment with customClass
const handleAddPayment = async () => {
  const amount = parseFloat(paymentAmount);
  const due = parseFloat(selectedPaymentPatient?.lab_due || 0);
  
  // ✅ Add payment mode validation
  if (!paymentMode || paymentMode.trim() === '') {
      Swal.fire({
          icon: 'error',
          title: 'Validation Error',
          text: 'Please select a payment mode',
          confirmButtonColor: '#405189',
          customClass: {
              container: 'swal2-payment-modal'  // ✅ Add this
          }
      });
      return;
  }
  
  // Validation
  if (!paymentAmount || amount <= 0) {
      Swal.fire({
          icon: 'error',
          title: 'Validation Error',
          text: 'Please enter a valid payment amount',
          confirmButtonColor: '#405189',
          customClass: {
              container: 'swal2-payment-modal'  // ✅ Add this
          }
      });
      return;
  }
  
  if (amount > due) {
      Swal.fire({
          icon: 'error',
          title: 'Validation Error',
          text: `Payment amount cannot exceed due amount (₹${due.toFixed(2)})`,
          confirmButtonColor: '#405189',
          customClass: {
              container: 'swal2-payment-modal'  // ✅ Add this
          }
      });
      return;
  }
  
  if (!paymentReceivedBy.trim()) {
      Swal.fire({
          icon: 'error',
          title: 'Validation Error',
          text: 'Please enter received by name',
          confirmButtonColor: '#405189',
          customClass: {
              container: 'swal2-payment-modal'  // ✅ Add this
          }
      });
      return;
  }
  
  try {
      const fd = new FormData();
      fd.append('lab_reg_id', selectedPaymentPatient.lab_reg_id);
      fd.append('payment_amount', amount);
      fd.append('payment_mode', paymentMode);
      fd.append('payment_received_by', paymentReceivedBy);
      fd.append('payment_remarks', paymentRemarks);
      fd.append('user_id', ldata?.user_id || '1');
      
      const response = await axios.post(
          AppConst.BASE_URL + AppConst.addPaymentUrl,
          fd,
          { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      
      if (response.data.status) {
          Swal.fire({
              icon: 'success',
              title: 'Success!',
              text: response.data.success || 'Payment added successfully',
              timer: 2000,
              showConfirmButton: false,
              customClass: {
                  container: 'swal2-payment-modal'  // ✅ Add this
              }
          });
          
          // Update the patient in the list
          setFormData(prev => ({
              ...prev,
              l1: (prev.l1 || []).map(patient => 
                  patient.lab_reg_id === selectedPaymentPatient.lab_reg_id
                      ? { ...patient, lab_paid: response.data.new_paid, lab_due: response.data.new_due }
                      : patient
              )
          }));
          
          // Clear form
          setPaymentAmount('');
          setPaymentRemarks('');
          setPaymentMode('');
          
          // Refresh payment history
          fetchPaymentHistory(selectedPaymentPatient.lab_reg_id);
          
          // Refresh the list
          initData();
          
          // Close modal after a short delay
          setTimeout(() => {
              setShowPaymentModal(false);
          }, 2000);
      } else {
          Swal.fire({
              icon: 'error',
              title: 'Error',
              text: response.data.success || 'Failed to add payment',
              confirmButtonColor: '#405189',
              customClass: {
                  container: 'swal2-payment-modal'  // ✅ Add this
              }
          });
      }
  } catch (error) {
      console.error("Payment error:", error);
      Swal.fire({
          icon: 'error',
          title: 'Server Error',
          text: 'Failed to add payment. Please try again.',
          confirmButtonColor: '#405189',
          customClass: {
              container: 'swal2-payment-modal'  // ✅ Add this
          }
      });
  }
};

// Helper to get test ID for params
const getTestIdForParams = (test) => {
  return test.test_id || 
         test.lab_item_test_id || 
         (test.params && test.params[0] && test.params[0].test_id) ||
         test.lab_item_id ||
         test.id;
};

const handleCheckboxChange = (test) => {
  const id = String(test.id);                                   // ✅ same id the checkbox uses
  const labItemTestId = String(test.lab_item_test_id || test.test_id || '');

  setSelectedTests(prev => {
    const arr = Array.isArray(prev) ? prev.slice() : [];
    const isSelected = arr.includes(id);

    // find duplicate instances of the same test type
    const sameTestIds = (currentTests || [])
      .filter(t => {
        const tId = String(t.lab_item_test_id || t.test_id || '');
        return tId === labItemTestId && tId !== '';
      })
      .map(t => String(t.id));

    let next;
    if (isSelected) {
      next = sameTestIds.length > 1
        ? arr.filter(p => !sameTestIds.includes(p))
        : arr.filter(p => p !== id);
    } else {
      if (sameTestIds.length > 1) {
        next = [...arr];
        sameTestIds.forEach(sid => { if (!next.includes(sid)) next.push(sid); });
      } else {
        next = [...arr, id];
      }
    }

    // keep "Select All" in sync in the same update (drop the old setTimeout)
    const allIds = (currentTests || []).map(t => String(t.id));
    setSelectAllTests(allIds.length > 0 && allIds.every(tid => next.includes(tid)));
    return next;
  });
};
// Toggle select all
const handleToggleSelectAll = () => {
  if (selectAllTests) {
    setSelectedTests([]);
    setSelectAllTests(false);
  } else {
    const allIds = (currentTests || []).map(t => String(t.id));
    setSelectedTests(allIds);
    setSelectAllTests(true);
  }
};



// Open report modal - FETCH PARAMS FOR TESTS THAT NEED THEM
// Open report modal - FETCH SAVED RESULTS (not master params!)
const openReportModal = async (tests, patientRow) => {
  console.log("=== openReportModal called ===");
  console.log("📋 Patient row:", patientRow);
  
  if (!patientRow) {
    console.error("❌ No patient data");
    toast.error("Patient data missing");
    return;
  }

  const regId = patientRow.lab_reg_id || patientRow.lab_item_parent || patientRow.id;
  
  if (!regId) {
    console.error("❌ No registration ID");
    toast.error("Cannot find patient registration ID");
    return;
  }
  const normalizedPatient = {
    ...patientRow,
    lab_reg_id: regId // ✅ Make sure this field exists
  };
  // Set patient
  setSelectedUserForPrint(patientRow);
  setSelectedUser(patientRow);

  // Show loading
  Swal.fire({
    title: 'Loading test results...',
    text: 'Please wait',
    allowOutsideClick: false,
    didOpen: () => Swal.showLoading()
  });

  try {
    // ✅ ALWAYS FETCH SAVED RESULTS from server (don't trust row data)
    console.log("📤 Fetching SAVED RESULTS for registration ID:", regId);
    
    const fd1 = new FormData();
    fd1.append('page_no', 'none');
    fd1.append('search_key', '');
    fd1.append('lab_item_parent', String(regId)); // ⚡ This fetches saved results!
    
    const response = await axios.post(
      AppConst.BASE_URL + AppConst.getLabRegListItmUrl,
      fd1,
      { 
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 20000 
      }
    );

    console.log("📥 API Response:", response.data);

    if (!response.data?.status || !Array.isArray(response.data.records)) {
      Swal.close();
      console.error("❌ Invalid API response");
      toast.error("Failed to fetch test results");
      return;
    }

    const records = response.data.records;
    
    if (records.length === 0) {
      Swal.close();
      console.error("❌ No records returned");
      console.log("💡 This means no saved results exist for this patient");
      console.log("💡 Patient may need to go to Report Entry first to save results");
      toast.error("No test results found. Please save results in Report Entry first.");
      return;
    }

    console.log("✅ Received", records.length, "test records WITH saved results");
    console.log("📋 Sample record:", records[0]);

    // ✅ Process records (backend already merged saved results into params!)
    const loaded = records.map((rec, idx) => {
      const testName = rec.lab_item_test_name || rec.test_name || rec.name || `Test ${idx + 1}`;
      
      console.log(`\n📋 Test ${idx + 1}: ${testName}`);
      console.log(`   Raw params:`, rec.params);
      
      // Extract interpretation
      let interp = (rec.interpretation && String(rec.interpretation).trim()) ? rec.interpretation : "";
      if (!interp && rec.test_interpretation) interp = rec.test_interpretation;
      if (!interp && rec.test_interpratation) interp = rec.test_interpratation;
      
      if (!interp && Array.isArray(rec.params) && rec.params.length > 0) {
        for (const p of rec.params) {
          if (p.test_interpretation && String(p.test_interpretation).trim()) { 
            interp = p.test_interpretation; 
            break; 
          }
          if (p.test_interpratation && String(p.test_interpratation).trim()) { 
            interp = p.test_interpratation; 
            break; 
          }
        }
      }

      // ✅ Normalize params (backend should have merged results already)
      const normalizedParams = (rec.params || []).map((p, pIdx) => {
        // Priority chain for result value
        const result = p.result || p.test_result || p.lab_item_result || '';
        
        if (pIdx === 0) {
          console.log(`   📊 First param:`, {
            name: p.test_param_name,
            result: result,
            result_field_exists: p.result !== undefined,
            test_result_field_exists: p.test_result !== undefined,
            lab_item_result_field_exists: p.lab_item_result !== undefined
          });
        }
        
        return {
          ...p,
          result: result,
          test_param_name: p.test_param_name || p.param_name || '',
          test_param_type: p.test_param_type || 'Text',
          test_range_type: p.test_range_type || '',
          test_param_from_range: p.test_param_from_range || '',
          test_param_to_range: p.test_param_to_range || '',
          test_param_method: p.test_param_method || '',
          test_sample_type: p.test_sample_type || rec.test_sample_type || '',
          test_cat: p.test_cat || rec.test_cat || ''
        };
      });

      const resultCount = normalizedParams.filter(p => p.result && String(p.result).trim() !== '').length;
      console.log(`   ✅ Params: ${normalizedParams.length}, With results: ${resultCount}`);

      return {
        ...rec,
        id: rec.lab_item_test_id || rec.lab_item_id || rec.id || `test-${idx}`,
        test_id: rec.test_id || rec.lab_item_test_id,
        lab_item_id: rec.lab_item_id, // ✅ preserve explicitly
        lab_item_test_id: rec.lab_item_test_id, 
        lab_item_test_name: testName,
        name: testName,
        params: normalizedParams,
        test_cat: normalizedParams[0]?.test_cat || rec.test_cat || '',
        test_sample_type: normalizedParams[0]?.test_sample_type || rec.test_sample_type || '',
        interpretation: interp ? String(interp) : "",
        impression: rec.impression || '',
        notes: rec.notes || '',
        report_info: rec.report_info || {
          test_report_id: rec.test_report_id || null,
          is_approved: rec.is_approved || "0"
        }
      };
    });

    console.log("\n✅ Final loaded tests:", loaded.length);
    loaded.forEach((t, i) => {
      const resultCount = t.params?.filter(p => p.result && String(p.result).trim() !== '').length || 0;
      console.log(`  ${i+1}. ${t.name}: ${t.params?.length || 0} params, ${resultCount} with results`);
    });

    Swal.close();

    setCurrentTests(loaded);
    setSelectedTests(loaded.map(t => String(t.id)));
    setSelectAllTests(true);
    setShowReportModal(true);

  } catch (err) {
    Swal.close();
    console.error("❌ openReportModal error:", err);
    Swal.fire({ 
      icon: 'error', 
      title: 'Error', 
      text: 'Failed to load test data: ' + (err.message || 'Unknown error')
    });
  }
};





const handlePrintClick = async () => {
  console.log("=== handlePrintClick START ===");

  if (!Array.isArray(selectedTests) || selectedTests.length === 0) {
    toast.error("Please select at least one test to print.");
    return;
  }

  const patient = selectedUserForPrint || selectedUser;
  if (!patient) {
    toast.error("No patient data available.");
    return;
  }

  Swal.fire({
    title: 'Preparing PDF...',
    text: 'Please wait...',
    allowOutsideClick: false,
    didOpen: () => Swal.showLoading()
  });

  try {
    // Filter selected tests - they already have params with results
    let testsToPrint = currentTests.filter(t => selectedTests.includes(String(t.id)));

    // ✅ Defensive: ensure uniqueness by lab_item_id so duplicate-test instances
    // each carry their own params and can't get merged/swapped in the PDF loop
    const seenLabItemIds = new Set();
    testsToPrint = testsToPrint.filter(t => {
      const key = String(t.lab_item_id || t.id);
      if (seenLabItemIds.has(key)) return false;
      seenLabItemIds.add(key);
      return true;
    });
    
    console.log("Tests to print:", testsToPrint);


    console.log("Tests with results:", testsToPrint.filter(t => 
      t.params && t.params.some(p => p.result && p.result.trim() !== '')
    ).length);

    Swal.close();

    if (testsToPrint.length === 0) {
      toast.error("No tests selected.");
      return;
    }

    // ✅ Tests already have params with results - pass directly to PDF generator
    await generatePdfForTests(testsToPrint);
    setShowReportModal(false);

  } catch (err) {
    Swal.close();
    console.error("❌ handlePrintClick error:", err);
    Swal.fire({ 
      icon: 'error', 
      title: 'Error', 
      text: 'Failed to generate PDF: ' + (err.message || 'Unknown error')
    });
  }
};



const handleSendWhatsApp = async () => {
  console.log("=== handleSendWhatsApp START ===");

  if (!Array.isArray(selectedTests) || selectedTests.length === 0) {
    toast.error("Please select at least one test to send.");
    return;
  }

  const patient = selectedUserForPrint || selectedUser;
  if (!patient) {
    toast.error("No patient data available.");
    return;
  }

  // Get patient mobile number
  const mobile = patient.lab_reg_mobile || '';
  
  if (!mobile || mobile.trim() === '') {
    Swal.fire({
      icon: 'error',
      title: 'No Mobile Number',
      text: 'Patient mobile number is not registered.',
      confirmButtonColor: '#405189'
    });
    return;
  }

  // Clean mobile number
  const cleanMobile = mobile.replace(/[^0-9]/g, '');
  
  if (cleanMobile.length < 10) {
    Swal.fire({
      icon: 'error',
      title: 'Invalid Mobile Number',
      text: 'Patient mobile number appears to be invalid.',
      confirmButtonColor: '#405189'
    });
    return;
  }

  let testsToPrint = currentTests.filter(t => selectedTests.includes(String(t.id)));
  
  if (testsToPrint.length === 0) {
    toast.error("No tests selected.");
    return;
  }

  // Confirm before sending
  const result = await Swal.fire({
    title: 'Send Notification via WhatsApp?',
    html: `
      <div style="text-align: left; padding: 10px;">
        <p><strong>Patient:</strong> ${patient.lab_reg_name || 'N/A'}</p>
        <p><strong>Mobile:</strong> ${mobile}</p>
        <p><strong>UHID:</strong> ${patient.lab_reg_uhid || 'N/A'}</p>
        <p><strong>Tests:</strong> ${testsToPrint.length}</p>
        <hr style="margin: 15px 0;">
        <p style="color: #666; font-size: 0.9em;">
          WhatsApp will open with a pre-filled message.
        </p>
      </div>
    `,
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#25D366',
    cancelButtonColor: '#6c757d',
    confirmButtonText: '<i class="ri-whatsapp-line"></i> Yes, Send',
    cancelButtonText: 'Cancel'
  });

  if (!result.isConfirmed) return;

  try {
    // Create message
    const patientName = patient.lab_reg_name || 'Patient';
    const uhid = patient.lab_reg_uhid || 'N/A';
    const hospitalName = "Astha Multispeciality Hospital"; // ✅ Replace with your hospital name
    
    const message = encodeURIComponent(
      `Dear ${patientName},\n\n` +
      `Your lab reports are ready.\n` +
      `UHID: ${uhid}\n` +
      `Tests: ${testsToPrint.length}\n\n` +
      `Thank you for choosing ${hospitalName}.\n\n` +
      `Please collect your reports or access them online.`
    );

    // Format mobile number for WhatsApp (add country code if needed)
    let whatsappNumber = cleanMobile;
    if (!whatsappNumber.startsWith('91') && whatsappNumber.length === 10) {
      whatsappNumber = '91' + whatsappNumber; // ✅ Add India country code
    }

    // Open WhatsApp with message
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${message}`;
    
    // Open in new window
    window.open(whatsappUrl, '_blank');
    
    // Show success message
    Swal.fire({
      icon: 'success',
      title: 'WhatsApp Opened!',
      html: `
        <div style="text-align: left;">
          <p>✅ WhatsApp has been opened with your message.</p>
          <p style="margin-top: 10px; color: #666; font-size: 0.9em;">
            Click send in WhatsApp to deliver the notification.
          </p>
        </div>
      `,
      confirmButtonColor: '#405189',
      timer: 3000
    });

    setShowReportModal(false);

  } catch (err) {
    console.error("❌ handleSendWhatsApp error:", err);
    Swal.fire({ 
      icon: 'error', 
      title: 'Error', 
      text: 'Failed to open WhatsApp: ' + (err.message || 'Unknown error'),
      confirmButtonColor: '#405189'
    });
  }
};



// ✅ Send Lab PDF Report via WhatsApp (Send as File, NOT Base64)
const handleSendLabPdfWhatsApp = async () => {
  console.log("=== handleSendLabPdfWhatsApp START ===");

  if (!Array.isArray(selectedTests) || selectedTests.length === 0) {
    toast.error("Please select at least one test to send.");
    return;
  }

  const patient = selectedUserForPrint || selectedUser;
  
  console.log("📋 Patient object:", patient);
  
  if (!patient) {
    toast.error("No patient data available.");
    return;
  }

  // ✅ Get registration ID with multiple fallbacks
  const labRegId = patient.lab_reg_id || 
                   patient.lab_item_parent || 
                   patient.id || 
                   patient.lab_reg_id_parent;
  
  console.log("🔑 Lab Reg ID:", labRegId);

  if (!labRegId) {
    console.error("❌ No lab_reg_id found in patient:", patient);
    Swal.fire({
      icon: 'error',
      title: 'Data Error',
      text: 'Cannot find patient registration ID. Please refresh and try again.',
      confirmButtonColor: '#405189'
    });
    return;
  }

  const mobile = patient.lab_reg_mobile || '';
  
  if (!mobile || mobile.trim() === '') {
    Swal.fire({
      icon: 'error',
      title: 'No Mobile Number',
      text: 'Patient mobile number is not registered.',
      confirmButtonColor: '#405189'
    });
    return;
  }

  const cleanMobile = mobile.replace(/[^0-9]/g, '');
  
  if (cleanMobile.length < 10) {
    Swal.fire({
      icon: 'error',
      title: 'Invalid Mobile Number',
      text: 'Patient mobile number appears to be invalid.',
      confirmButtonColor: '#405189'
    });
    return;
  }

  let testsToPrint = currentTests.filter(t => selectedTests.includes(String(t.id)));
  
  if (testsToPrint.length === 0) {
    toast.error("No tests selected.");
    return;
  }

  // Confirm
  const result = await Swal.fire({
    title: 'Send PDF Report via WhatsApp?',
    html: `
      <div style="text-align: left; padding: 10px;">
        <p><strong>Patient:</strong> ${patient.lab_reg_name || 'N/A'}</p>
        <p><strong>Mobile:</strong> ${mobile}</p>
        <p><strong>UHID:</strong> ${patient.lab_reg_uhid || 'N/A'}</p>
        <p><strong>Reg ID:</strong> ${labRegId}</p>
        <p><strong>Tests:</strong> ${testsToPrint.length}</p>
        <hr style="margin: 15px 0;">
        <p style="color: #666; font-size: 0.9em;">
          📄 PDF will be automatically attached and sent via WhatsApp
        </p>
      </div>
    `,
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#25D366',
    cancelButtonColor: '#6c757d',
    confirmButtonText: '<i class="ri-file-pdf-line"></i> Yes, Send PDF',
    cancelButtonText: 'Cancel'
  });

  if (!result.isConfirmed) return;

  try {
    Swal.fire({
      title: 'Generating & Sending PDF...',
      text: 'Please wait...',
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading()
    });

    // ✅ Generate PDF Blob
    console.log("📄 Generating PDF for", testsToPrint.length, "tests...");
    const pdfBlob = await generatePdfBlobForWhatsApp(testsToPrint);
    
    if (!pdfBlob) {
      throw new Error("Failed to generate PDF");
    }

    console.log("✅ PDF generated, size:", pdfBlob.size, "bytes");

    // ✅ Create FormData and send PDF as FILE (not base64!)
    const fd = new FormData();
    fd.append('lab_reg_id', String(labRegId));
    fd.append('test_ids', JSON.stringify(selectedTests));
    fd.append('user_id', String(ldata?.user_id || '1'));
    
    // ✅ Append PDF as actual file (much more efficient than base64!)
    const filename = `lab_report_${labRegId}_${Date.now()}.pdf`;
    fd.append('pdf_file', pdfBlob, filename);

    console.log("📤 Sending to backend:", {
      lab_reg_id: labRegId,
      test_count: selectedTests.length,
      user_id: ldata?.user_id || '1',
      pdf_size: pdfBlob.size,
      filename: filename
    });

    const response = await axios.post(
      AppConst.BASE_URL + AppConst.send_lab_report_pdf_whatsapp,
      fd,
      { 
        headers: { 
          'Content-Type': 'multipart/form-data'
        },
        timeout: 60000, // 60 seconds
        maxContentLength: Infinity,
        maxBodyLength: Infinity
      }
    );

    console.log("📥 Backend response:", response.data);

    Swal.close();

    if (response.data && response.data.status) {
      // ✅ Success
      Swal.fire({
        icon: 'success',
        title: 'PDF Sent Successfully!',
        html: `
          <div style="text-align: left;">
            <p>✅ ${response.data.message || 'Lab report PDF sent via WhatsApp'}</p>
            ${response.data.request_id ? `<p><small>Request ID: ${response.data.request_id}</small></p>` : ''}
            <hr style="margin: 15px 0;">
            <p style="color: #666; font-size: 0.9em;">
              The patient will receive the PDF report on WhatsApp automatically.
            </p>
          </div>
        `,
        confirmButtonColor: '#405189',
        timer: 5000
      });

      setShowReportModal(false);

    } else {
      // ✅ Failed
      Swal.fire({
        icon: 'error',
        title: 'Failed to Send',
        html: `
          <p>${response.data?.message || 'Could not send WhatsApp PDF'}</p>
          ${response.data?.debug ? `<hr/><pre>${JSON.stringify(response.data.debug, null, 2)}</pre>` : ''}
        `,
        confirmButtonColor: '#405189'
      });
    }

  } catch (err) {
    Swal.close();
    console.error("❌ handleSendLabPdfWhatsApp error:", err);
    
    let errorMsg = 'Failed to send WhatsApp PDF';
    if (err.response?.data?.message) {
      errorMsg = err.response.data.message;
    } else if (err.message) {
      errorMsg = err.message;
    }
    
    Swal.fire({ 
      icon: 'error', 
      title: 'Error', 
      html: `
        <p>${errorMsg}</p>
        <hr/>
        <small>Debug Info:</small><br/>
        <small>Patient ID: ${labRegId || 'NOT FOUND'}</small><br/>
        <small>Mobile: ${mobile}</small>
      `,
      confirmButtonColor: '#405189'
    });
  }
};

// Generate PDF as blob for WhatsApp (same as generatePdfForTests but returns blob)
// Generate PDF as blob for WhatsApp (same as generatePdfForTests but returns blob)
const generatePdfBlobForWhatsApp = async (testsToPrint) => {
  await loadThemeConfig();  
  try {
    const patient = selectedUserForPrint || selectedUser;
    
    if (!patient) {
      console.error("No patient selected");
      return null;
    }

    const doc = new jsPDF();
let fontOk = false;
let boldOk = false;

// --- REGULAR DejaVu ---
try {
  let fontBase64 = await loadFontAsBase64(`${process.env.PUBLIC_URL || ''}/DejaVuSans.ttf`);
  fontBase64 = String(fontBase64).replace(/^data:.*;base64,/, "");
  if (!fontBase64 || fontBase64.length < 5000) throw new Error("Regular font invalid");
  doc.addFileToVFS("DejaVuSans.ttf", fontBase64);
  doc.addFont("DejaVuSans.ttf", "DejaVu", "normal");
  doc.setFont("DejaVu", "normal");
  doc.getTextWidth("A");
  fontOk = true;
} catch (e) { console.error("DejaVu normal failed:", e.message); fontOk = false; }

// --- REAL BOLD DejaVu ---
try {
  let boldBase64 = await loadFontAsBase64(`${process.env.PUBLIC_URL || ''}/DejaVuSans-Bold.ttf`);
  boldBase64 = String(boldBase64).replace(/^data:.*;base64,/, "");
  if (!boldBase64 || boldBase64.length < 5000) throw new Error("Bold font missing/invalid");
  doc.addFileToVFS("DejaVuSans-Bold.ttf", boldBase64);
  doc.addFont("DejaVuSans-Bold.ttf", "DejaVu", "bold");
  doc.setFont("DejaVu", "bold");
  doc.getTextWidth("A");
  boldOk = true;
} catch (e) { console.error("DejaVu bold failed:", e.message); boldOk = false; }

doc.setFont(fontOk ? "DejaVu" : "helvetica", "normal");



    const pageHeight = doc.internal.pageSize.getHeight();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageBuffer = 35;
    
    // ✅ NEW: Constants for signature area protection
    const SIGNATURE_AREA_HEIGHT = 50;
    const MIN_TEST_CONTENT_HEIGHT = 45;
    
    let hasRadiology = false;
    let currentPageNumber = 1;
    let lastPrintedDeptOnCurrentPage = null;
    let currentTestDeptName = null;
    // Helper to add new page
  // ✅ UPDATED: Helper to add new page - resets department tracking
const addNewPage = async () => {
  doc.addPage();
  currentPageNumber++;
  lastPrintedDeptOnCurrentPage = null; // ✅ Reset so department header prints on new page
  await addHeaderAndFooter(doc);
  return await printPatientDetails(doc, patient, 36);
};

// ✅ NEW: Helper function to print department header
const printDepartmentHeader = (deptName) => {
  doc.setFillColor(...THEME.headerBg);
  doc.setDrawColor(...THEME.border);
  doc.setLineWidth(0.2);
  const r = THEME.outline.deptHeader ? (+THEME.outline.radius || 0) : 0;
  const style = THEME.outline.deptHeader ? 'FD' : 'F';
  if (r > 0) doc.roundedRect(10, yPos - 5, 190, 8, r, r, style);
  else doc.rect(10, yPos - 5, 190, 8, style);
  doc.setFontSize(THEME.font.deptHeader).setFont('helvetica', 'bold').setTextColor(...THEME.headerTxt);
  doc.text(deptName.toUpperCase(), pageWidth / 2, yPos, { align: 'center' });
  doc.setTextColor(0, 0, 0);
  yPos += 5;
  lastPrintedDeptOnCurrentPage = deptName;
};

    // Start first page
    await addHeaderAndFooter(doc);
    let yPos = await printPatientDetails(doc, patient, 36);
    let lastPrintedDept = null;

    // Helper function to draw the main parameter table
    // ✅ UPDATED: Helper function to draw the main parameter table with department reprinting
const drawMainTable = async (rows, needsHead) => {
  if (!rows || rows.length <= 1) return; // Skip if only main test name row

  const tableHeightEstimate = rows.length * 8 + (needsHead ? 10 : 0);
  
  // Check against signature area
  if (yPos + tableHeightEstimate > pageHeight - SIGNATURE_AREA_HEIGHT) {
    yPos = await addNewPage();
    
    // ✅ On new page, reprint department header if needed
    if (currentTestDeptName && currentTestDeptName !== lastPrintedDeptOnCurrentPage) {
      printDepartmentHeader(currentTestDeptName);
    }
    
    needsHead = true; // Always need table header on new page
  }

      const C = THEME.columns;
const tableStartY = yPos;
const startPageNo = doc.internal.getNumberOfPages();

await autoTable(doc, {
  startY: yPos,
  head: needsHead ? [["TEST NAME", "RESULT", "UNITS", "NORMAL RANGES", "METHOD"]] : null,
  body: rows,
  theme: 'plain',
  headStyles: {
    fillColor: THEME.headerBg, textColor: THEME.headerTxt,
    fontStyle: 'bold', fontSize: THEME.font.tableHead
  },
  styles: { fontSize: THEME.font.tableBody, cellPadding: 2, valign: 'middle', textColor: [0,0,0] },
  columnStyles: {
    0: { cellWidth: C.testName.width, halign: C.testName.halign },
    1: { cellWidth: C.result.width,   halign: C.result.halign   },
    2: { cellWidth: C.unit.width,     halign: C.unit.halign     },
    3: { cellWidth: C.range.width,    halign: C.range.halign    },
    4: { cellWidth: C.method.width,   halign: C.method.halign   }
  },
  margin: { left: 10, right: 10 },
  didDrawCell: (data) => {
    // existing main-test underline
    if (data.section === 'body' && data.row.index === 0 && data.cell.raw?.isMainTest) {
      doc.setDrawColor(...THEME.border);
      doc.setLineWidth(0.2);
      const tw = doc.getTextWidth(data.cell.text[0]);
      const lineY = data.cell.y + data.cell.height - 1.5;
      doc.line(data.cell.x + 2, lineY, data.cell.x + 2 + tw, lineY);
    }
  
    // ✅ draw the arrow after the number, in DejaVu (helvetica can't render ↑)
    // ✅ underline + arrow for abnormal result
if (
  data.section === 'body' &&
  data.column.index === 1 &&              // RESULT column
  data.cell.raw?._flag                    // this cell has a flag
) {
  const flag = data.cell.raw._flag;
  const numberText = String(data.cell.text[0] || '');

  // measure the number in its own (helvetica bold) font
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(THEME.font.tableBody);
  const numW = doc.getTextWidth(numberText);

  const textX     = data.cell.x + data.cell.padding('left');
  const baselineY = data.cell.y + data.cell.height / 2 + 1;

  // ✅ NEW: underline just the number, same color as the flag
  doc.setDrawColor(...flag.color);
  doc.setLineWidth(0.2);
  doc.line(textX, baselineY + 1, textX + numW, baselineY + 1);

  // arrow after the number, drawn in DejaVu
  if (fontOk) doc.setFont('DejaVu', 'normal');
  doc.setTextColor(...flag.color);
  const arrowX = textX + numW + 1.5;
  doc.text(flag.label, arrowX, baselineY);

  // reset
  doc.setTextColor(0, 0, 0);
  doc.setFont('helvetica', 'normal');
}
  },
});

const endY = doc.lastAutoTable?.finalY ?? yPos;
if (doc.internal.getNumberOfPages() === startPageNo) {
  drawOutline(doc, THEME.outline.testTable, 10, tableStartY, 190, endY - tableStartY);
}
yPos = endY + 4;
};

    // Build department map
    const departmentMap = {};
    (formData.departs || []).forEach(d => { departmentMap[d.cat_id] = d.cat_name; });

    // Loop through tests (same logic as generatePdfForTests)
    for (const test of testsToPrint) {
      const params = Array.isArray(test.params) ? test.params : [];

      if (params.length === 0) {
        continue;
      }

      // ✅ NEW: Check if we have enough space before starting this test
      if (yPos + MIN_TEST_CONTENT_HEIGHT > pageHeight - SIGNATURE_AREA_HEIGHT) {
        yPos = await addNewPage();
      }

     // Determine department
const deptName = (params[0] && params[0].test_cat && departmentMap[params[0].test_cat])
? departmentMap[params[0].test_cat]
: "OTHER REPORTS";

// ✅ Store current test's department for reprinting on new pages
currentTestDeptName = deptName;

if (deptName && deptName.toLowerCase() === "radiology") {
hasRadiology = true;
}

// ✅ UPDATED: Print department header only if different from last printed on THIS page
let addTableHead = false;
if (deptName && deptName !== lastPrintedDeptOnCurrentPage) {
// Check space for department header + test content
if (yPos + 15 + MIN_TEST_CONTENT_HEIGHT > pageHeight - SIGNATURE_AREA_HEIGHT) { 
  yPos = await addNewPage(); 
}
printDepartmentHeader(deptName);
addTableHead = true;
}

      // ✅ NEW: Check space before test name row
    // ✅ UPDATED: Before drawing test name row, check if we have space
const spaceForTestBlock = 40; // test name + header + at least 2 param rows
if (yPos + spaceForTestBlock > pageHeight - SIGNATURE_AREA_HEIGHT) {
  yPos = await addNewPage();
  
  // ✅ On new page, reprint department header
  if (deptName && deptName !== lastPrintedDeptOnCurrentPage) {
    printDepartmentHeader(deptName);
  }
  
  addTableHead = true; // Need to add table header on new page
}

      let paramsRows = [];
      const mainTestNameRow = [{
        content: test.lab_item_test_name || test.test_name || 'Test',
        colSpan: 5,
        styles: { fontStyle: 'bold', textColor: [0, 0, 0], cellPadding: { top: 2, bottom: 2, left: 2 } },
        isMainTest: true
      }];
      paramsRows.push(mainTestNameRow);

      let hasResultInCurrentTable = false;

      for (const param of params) {
        const rawParamName = String(param.test_param_name || '');
        const isPdfStarred = /^\*.+\*$/.test(rawParamName.trim());
        const pdfParamName = isPdfStarred ? rawParamName.trim().replace(/^\*(.+)\*$/, '$1') : rawParamName;

        if (param.test_param_type === "Editor") {
          if (hasResultInCurrentTable) {
            await drawMainTable(paramsRows, addTableHead);
            paramsRows = [mainTestNameRow];
            hasResultInCurrentTable = false;
            addTableHead = true;
          }

          // ✅ UPDATED: Check against signature area
          // ✅ UPDATED: Check against signature area with department reprinting
if (yPos + 12 > pageHeight - SIGNATURE_AREA_HEIGHT) { 
  yPos = await addNewPage();
  // Reprint department header on new page
  if (currentTestDeptName && currentTestDeptName !== lastPrintedDeptOnCurrentPage) {
    printDepartmentHeader(currentTestDeptName);
  }
}
yPos += 4;
          doc.setFontSize(11);
          doc.setFont('helvetica', 'bold');
          doc.text(pdfParamName, 16, yPos);
          yPos += 7;

          const editorContent = String(param.result || '').trim();
          if (editorContent) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = editorContent;
            const tableElement = tempDiv.querySelector('table');

            const htmlContentToRender = (() => {
              if (!tableElement) return tempDiv.innerHTML;
              const cloned = tempDiv.cloneNode(true);
              const tbl = cloned.querySelector('table');
              if (tbl) tbl.remove();
              return cloned.innerHTML;
            })();

            if (htmlContentToRender && String(htmlContentToRender).trim()) {
              yPos = await drawHtmlContent(doc, htmlContentToRender, 16, yPos, {
                maxWidth: 178,
                addNewPage,
                pageHeight,
                pageBuffer: SIGNATURE_AREA_HEIGHT // ✅ Use signature area height
              });
              yPos += 4;
            }

            if (tableElement) {
              // ✅ UPDATED: Check against signature area with department reprinting
              if (yPos + 12 > pageHeight - SIGNATURE_AREA_HEIGHT) {
                yPos = await addNewPage();
                if (currentTestDeptName && currentTestDeptName !== lastPrintedDeptOnCurrentPage) {
                  printDepartmentHeader(currentTestDeptName);
                }
              }
              try {
                autoTable(doc, {
                  startY: yPos,
                  html: tableElement,
                  theme: 'grid',
                  styles: {
                    fontSize: 9,
                    cellPadding: 2,
                    valign: 'middle',
                    textColor: [0, 0, 0],
                    lineColor: [0, 0, 0],
                    lineWidth: 0.2
                  },
                  headStyles: {
                    textColor: [0, 0, 0],
                    fillColor: [255, 255, 255],
                    fontStyle: 'bold'
                  },
                  margin: { left: 14, right: 14 }
                });
                yPos = doc.lastAutoTable ? doc.lastAutoTable.finalY + 6 : yPos + 17;
              } catch (err) {
                console.warn("Table render failed", err);
              }
            }
          }

          yPos += 6;
          continue;
        }

        const hasResult = param.result !== undefined && param.result !== null && String(param.result).trim() !== '';
        if (!hasResult && !isPdfStarred) {
          continue;
        }

        
      // Check for H/L/B flags — gender-aware
let resultWithFlag = hasResult ? String(param.result).trim() : '';
let resultStyles = {
  halign: THEME.columns.result.halign,
  textColor: [0, 0, 0],
  ...(fontOk ? { font: 'DejaVu' } : {})
};

const rangeValue = formatCellValue(get_param_val(param));

if (hasResult) {
  const flag = evaluateFlagSmart(resultWithFlag, rangeValue, patient);
  if (flag) {
    resultWithFlag = `${resultWithFlag} ${flag.label}`;
    if (boldOk) {
      // real DejaVu bold → bold + arrow
      resultStyles = { ...resultStyles, textColor: flag.color, fontStyle: 'bold', font: 'DejaVu' };
    } else {
      // no bold font → DejaVu normal so arrow shows, skip bold to avoid crash
      resultStyles = { ...resultStyles, textColor: flag.color, font: fontOk ? 'DejaVu' : 'helvetica' };
    }
  }

  if (param.is_bold === true) {
    if (boldOk) {
      resultStyles = { ...resultStyles, fontStyle: 'bold', textColor: THEME.flags.boldColor, font: 'DejaVu' };
    } else {
      resultStyles = { ...resultStyles, textColor: THEME.flags.boldColor, font: fontOk ? 'DejaVu' : 'helvetica' };
    }
  }
}

paramsRows.push([
  { content: pdfParamName, styles: isPdfStarred ? { fontStyle: 'bold' } : {} },
  { content: resultWithFlag || '', styles: resultStyles },
  param.test_range_type || '',
  genderRangeDisplay(rangeValue, patient) || '',   // narrows to patient's range if THEME.genderRange.showOnlyMatched = 1
  param.test_param_method || ''
]);

hasResultInCurrentTable = true;
      }

      if (hasResultInCurrentTable) {
        await drawMainTable(paramsRows, addTableHead);
      }

      const isRadiologyDept = (deptName && String(deptName).toLowerCase() === 'radiology') ||
        (params[0] && String(params[0].test_cat) === '60');

        if (!isRadiologyDept && params[0] && params[0].test_sample_type) {
          // ✅ UPDATED: Check against signature area with department reprinting
          if (yPos + 15 > pageHeight - SIGNATURE_AREA_HEIGHT) {
            yPos = await addNewPage();
            if (currentTestDeptName && currentTestDeptName !== lastPrintedDeptOnCurrentPage) {
              printDepartmentHeader(currentTestDeptName);
            }
          }
        autoTable(doc, {
          startY: yPos,
          body: [[{
            content: `Sample Type : ${params[0].test_sample_type}`,
            colSpan: 5,
            styles: { fontStyle: 'bold', textColor: [80, 80, 80] }
          }]],
          theme: 'plain',
          styles: { fontSize: 8, cellPadding: 1, valign: 'middle' },
          margin: { left: 14, right: 14 }
        });
        yPos = doc.lastAutoTable ? doc.lastAutoTable.finalY + 6 : yPos + 10;
      } else {
        yPos += 4;
      }

      // ✅ UPDATED: Check space before bordered sections
     // ✅ UPDATED: Interpretation / Impression / Notes - with department reprinting
if (test.interpretation) {
  if (yPos + 20 > pageHeight - SIGNATURE_AREA_HEIGHT) {
    yPos = await addNewPage();
    if (currentTestDeptName && currentTestDeptName !== lastPrintedDeptOnCurrentPage) {
      printDepartmentHeader(currentTestDeptName);
    }
  }
  yPos = await drawBorderedSection(doc, 'Interpretation', test.interpretation, yPos, addNewPage, pageHeight, SIGNATURE_AREA_HEIGHT);
}
if (test.impression) {
  if (yPos + 20 > pageHeight - SIGNATURE_AREA_HEIGHT) {
    yPos = await addNewPage();
    if (currentTestDeptName && currentTestDeptName !== lastPrintedDeptOnCurrentPage) {
      printDepartmentHeader(currentTestDeptName);
    }
  }
  yPos = await drawBorderedSection(doc, 'Impression', test.impression, yPos, addNewPage, pageHeight, SIGNATURE_AREA_HEIGHT);
}
if (test.notes) {
  if (yPos + 20 > pageHeight - SIGNATURE_AREA_HEIGHT) {
    yPos = await addNewPage();
    if (currentTestDeptName && currentTestDeptName !== lastPrintedDeptOnCurrentPage) {
      printDepartmentHeader(currentTestDeptName);
    }
  }
  yPos = await drawBorderedSection(doc, 'Notes:', test.notes, yPos, addNewPage, pageHeight, SIGNATURE_AREA_HEIGHT);
}
    }

    if (yPos + 20 > pageHeight - SIGNATURE_AREA_HEIGHT) yPos = await addNewPage();
    doc.setFontSize(12).setFont('helvetica', 'bold');
    doc.text('*** End of Report ***', pageWidth / 2, yPos + 12, { align: 'center' });

    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      if (hasRadiology) {
        await addSignatures(doc, formData.selItem['60']);
      } else {
        await addSignatures(doc, formData.selItem['32']);
      }
      
      doc.setFontSize(8).setTextColor(0, 0, 0);
      const pageText = `Page ${i} of ${totalPages}`;
      doc.text(pageText, pageWidth - 14, pageHeight - 18, { align: 'right' });
    }

    // Return blob instead of opening
    return doc.output('blob');

  } catch (err) {
    console.error("generatePdfBlobForWhatsApp error:", err);
    return null;
  }
};
// Update handleDeletePayment
const handleDeletePayment = async (paymentId) => {
  const userRole = ldata?.type || ldata?.user_type || '';
  
  if (userRole !== 'admin' && userRole !== 'Admin') {
      Swal.fire({
          icon: 'warning',
          title: 'Permission Denied',
          text: 'Only administrators can delete payments',
          confirmButtonColor: '#405189',
          customClass: {
              container: 'swal2-payment-modal'  // ✅ Add this
          }
      });
      return;
  }
  
  const result = await Swal.fire({
      title: 'Delete Payment?',
      text: "This will reverse the payment and update the due amount.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
      customClass: {
          container: 'swal2-payment-modal'  // ✅ Add this
      }
  });
  
  if (!result.isConfirmed) return;
  
  try {
      const fd = new FormData();
      fd.append('payment_id', paymentId);
      fd.append('user_role', userRole);
      attachUserInfo(fd);
      const response = await axios.post(
          //AppConst.BASE_URL + AppConst.deletePaymentUrl,

          AppConst.BASE_URL + AppConst.deleteLabPaymentUrl,
          fd,
          { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      
      if (response.data.status) {
          Swal.fire({
              icon: 'success',
              title: 'Deleted!',
              text: response.data.success || 'Payment deleted successfully',
              timer: 2000,
              showConfirmButton: false,
              customClass: {
                  container: 'swal2-payment-modal'  // ✅ Add this
              }
          });
          
          // Update patient in list
          setFormData(prev => ({
              ...prev,
              l1: (prev.l1 || []).map(patient => 
                  patient.lab_reg_id === selectedPaymentPatient.lab_reg_id
                      ? { ...patient, lab_paid: response.data.new_paid, lab_due: response.data.new_due }
                      : patient
              )
          }));
          
          // Refresh payment history
          fetchPaymentHistory(selectedPaymentPatient.lab_reg_id);
          
          // Refresh the list
          initData();
      } else {
          Swal.fire({
              icon: 'error',
              title: 'Error',
              text: response.data.success || 'Failed to delete payment',
              confirmButtonColor: '#405189',
              customClass: {
                  container: 'swal2-payment-modal'  // ✅ Add this
              }
          });
      }
  } catch (error) {
      console.error("Delete payment error:", error);
      Swal.fire({
          icon: 'error',
          title: 'Server Error',
          text: 'Failed to delete payment. Please try again.',
          confirmButtonColor: '#405189',
          customClass: {
              container: 'swal2-payment-modal'  // ✅ Add this
          }
      });
  }
};


// Open refund modal
const openRefundModal = () => {
  if (!selectedPaymentPatient) return;
  const paidAmount = parseFloat(selectedPaymentPatient.lab_paid || 0);
  
  if (paidAmount <= 0) {
    Swal.fire({
      icon: 'info',
      title: 'No Payment to Refund',
      text: 'This patient has no paid amount to refund.',
      confirmButtonColor: '#405189',
      customClass: { container: 'swal2-payment-modal' }
    });
    return;
  }
  
  setRefundAmount('');
  setRefundMode('');
  setRefundRemarks('');
  setRefundedBy(Name);
  fetchRefundHistory(selectedPaymentPatient.lab_reg_id);
  setShowRefundModal(true);
};

// Fetch refund history
const fetchRefundHistory = async (labRegId) => {
  if (!labRegId) return;
  try {
    const fd = new FormData();
    fd.append('lab_reg_id', labRegId);
    const response = await axios.post(
      AppConst.BASE_URL + AppConst.getLabRefundHistoryUrl,
      fd,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    if (response.data.status) {
      setRefundHistory(response.data.records || []);
    }
  } catch (error) {
    console.error("Error fetching refund history:", error);
  }
};

// Process refund
const handleProcessRefund = async () => {
  const amount = parseFloat(refundAmount);
  const paid = parseFloat(selectedPaymentPatient?.lab_paid || 0);
  
  // Validations
  if (!refundMode || refundMode.trim() === '') {
    Swal.fire({
      icon: 'error', title: 'Validation Error',
      text: 'Please select a refund mode',
      confirmButtonColor: '#405189',
      customClass: { container: 'swal2-payment-modal' }
    });
    return;
  }
  
  if (!refundAmount || amount <= 0) {
    Swal.fire({
      icon: 'error', title: 'Validation Error',
      text: 'Please enter a valid refund amount',
      confirmButtonColor: '#405189',
      customClass: { container: 'swal2-payment-modal' }
    });
    return;
  }
  
  if (amount > paid) {
    Swal.fire({
      icon: 'error', title: 'Validation Error',
      text: `Refund amount cannot exceed paid amount (₹${paid.toFixed(2)})`,
      confirmButtonColor: '#405189',
      customClass: { container: 'swal2-payment-modal' }
    });
    return;
  }
  
  if (!refundRemarks || refundRemarks.trim() === '') {
    Swal.fire({
      icon: 'error', title: 'Validation Error',
      text: 'Remarks are mandatory for refund',
      confirmButtonColor: '#405189',
      customClass: { container: 'swal2-payment-modal' }
    });
    return;
  }
  
  // Confirm
  const confirm = await Swal.fire({
    title: 'Confirm Refund?',
    html: `
      <div style="text-align: left; padding: 10px;">
        <p><strong>Patient:</strong> ${selectedPaymentPatient.lab_reg_name}</p>
        <p><strong>Refund Amount:</strong> ₹${amount.toFixed(2)}</p>
        <p><strong>Mode:</strong> ${refundMode}</p>
        <p><strong>Remarks:</strong> ${refundRemarks}</p>
        <p style="color:#dc3545; margin-top: 10px;"><strong>⚠️ This will reduce the paid amount.</strong></p>
      </div>
    `,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#dc3545',
    confirmButtonText: 'Yes, Process Refund',
    cancelButtonText: 'Cancel',
    customClass: { container: 'swal2-payment-modal' }
  });
  
  if (!confirm.isConfirmed) return;
  
  setRefundProcessing(true);
  
  try {
    const fd = new FormData();
    fd.append('lab_reg_id', selectedPaymentPatient.lab_reg_id);
    fd.append('refund_amount', amount);
    fd.append('refund_mode', refundMode);
    fd.append('refund_remarks', refundRemarks);
    fd.append('refunded_by', refundedBy);
    fd.append('user_id', ldata?.user_id || '1');
    attachUserInfo(fd);
    
    const response = await axios.post(
      AppConst.BASE_URL + AppConst.addLabRefundUrl,
      fd,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    
    if (response.data.status) {
      Swal.fire({
        icon: 'success', title: 'Refund Recorded!',
        text: 'Refund saved successfully',
        timer: 2000, showConfirmButton: false,
        customClass: { container: 'swal2-payment-modal' }
      });
      if (response.data.refund_map) {
        setLabRefundMap(response.data.refund_map);
      }
     

      // Update patient in list
      // setFormData(prev => ({
      //   ...prev,
      //   l1: (prev.l1 || []).map(patient =>
      //     patient.lab_reg_id === selectedPaymentPatient.lab_reg_id
      //       ? { ...patient, lab_paid: response.data.new_paid, lab_due: response.data.new_due }
      //       : patient
      //   )
      // }));
      
      // Update local state too
      // setSelectedPaymentPatient(prev => ({
      //   ...prev,
      //   lab_paid: response.data.new_paid,
      //   lab_due: response.data.new_due
      // }));
      
      // Clear form
      setRefundAmount('');
      setRefundRemarks('');
      setRefundMode('');
      
      // Refresh histories
      fetchRefundHistory(selectedPaymentPatient.lab_reg_id);
      fetchPaymentHistory(selectedPaymentPatient.lab_reg_id);
      initData();
      
      setTimeout(() => setShowRefundModal(false), 2000);
    } else {
      Swal.fire({
        icon: 'error', title: 'Error',
        text: response.data.success || 'Refund failed',
        confirmButtonColor: '#405189',
        customClass: { container: 'swal2-payment-modal' }
      });
    }
  } catch (error) {
    console.error("Refund error:", error);
    Swal.fire({
      icon: 'error', title: 'Server Error',
      text: 'Failed to process refund. Please try again.',
      confirmButtonColor: '#405189',
      customClass: { container: 'swal2-payment-modal' }
    });
  } finally {
    setRefundProcessing(false);
  }
};

// Delete refund (Admin only)
const handleDeleteRefund = async (refundId) => {
  const userRole = ldata?.type || ldata?.user_type || '';
  if (userRole !== 'admin' && userRole !== 'Admin') {
    Swal.fire({
      icon: 'warning', title: 'Permission Denied',
      text: 'Only administrators can delete refunds',
      confirmButtonColor: '#405189',
      customClass: { container: 'swal2-payment-modal' }
    });
    return;
  }
  
  const result = await Swal.fire({
    title: 'Delete Refund?',
    text: "This will reverse the refund (add the amount back to paid).",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!',
    customClass: { container: 'swal2-payment-modal' }
  });
  
  if (!result.isConfirmed) return;
  
  try {
    const fd = new FormData();
    fd.append('refund_id', refundId);
    fd.append('user_role', userRole);
    attachUserInfo(fd);
    
    const response = await axios.post(
      AppConst.BASE_URL + AppConst.deleteLabRefundUrl,
      fd,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    
    if (response.data.status) {
      Swal.fire({
        icon: 'success', title: 'Deleted!',
        text: 'Refund reversed successfully',
        timer: 2000, showConfirmButton: false,
        customClass: { container: 'swal2-payment-modal' }
      });
      
      // ✅ Update refund map from response (if backend returns it)
      if (response.data.refund_map) {
        setLabRefundMap(response.data.refund_map);
      }
      
      fetchRefundHistory(selectedPaymentPatient.lab_reg_id);
      initData(); // Refresh list to get updated refund_map
    }else {
      Swal.fire({
        icon: 'error', title: 'Error',
        text: response.data.success || 'Failed to delete refund',
        confirmButtonColor: '#405189',
        customClass: { container: 'swal2-payment-modal' }
      });
    }
  } catch (error) {
    console.error("Delete refund error:", error);
  }
};
// filterType: 'total' | 'discount' | 'paid' | 'due'
const openFooterModal = (filterType) => {
  const rows = groupedData || [];
  let filtered = [];

  switch (filterType) {
    case 'total':
      // show rows where lab_total > 0
      filtered = rows.filter(r => Number(r.lab_total ?? 0) > 0);
      setFooterModalTitle('Patients with Total Charges > 0');
      break;
    case 'discount':
      filtered = rows.filter(r => {
        const dis = computeDiscountAmount ? computeDiscountAmount(r) : 0;
        return Number(dis) > 0;
      });
      setFooterModalTitle('Patients with Discount > 0');
      break;
    case 'paid':
      filtered = rows.filter(r => Number(r.lab_paid ?? 0) > 0);
      setFooterModalTitle('Patients with Paid Amount > 0');
      break;
    case 'due':
      filtered = rows.filter(r => Number(r.lab_due ?? 0) > 0);
      setFooterModalTitle('Patients with Due Amount > 0');
      break;
    default:
      filtered = rows;
      setFooterModalTitle('Patients');
  }

  setFooterModalRows(filtered);
  setShowFooterModal(true);
};

// Open totals modal with filtered list based on type
const handleTotalsClick = (type) => {
  const rows = groupedData || [];
  let filtered = [];

  switch (type) {
    case 'due':
      filtered = rows.filter(r => Number(r.lab_due ?? 0) > 0);
      break;
    case 'paid':
      filtered = rows.filter(r => Number(r.lab_paid ?? 0) > 0);
      break;
    case 'discount':
      filtered = rows.filter(r => {
        const disPer = Number(r.lab_dis_per ?? 0);
        const fixDep = Number(r.lab_fix_deposit ?? 0);
        const labTotal = Number(r.lab_total ?? 0);
        if (disPer > 0 && labTotal > 0) return true;
        if (fixDep > 0) return true;
        return false;
      });
      break;
    case 'total':
    default:
      // show everything where lab_total > 0
      filtered = rows.filter(r => Number(r.lab_total ?? 0) > 0);
  }

  setTotalsModalType(type);
  setTotalsModalList(filtered);
  setShowTotalsModal(true);
};

const discountSourceLabel = (r) => {
  const disPerc = Number(r.lab_dis_per ?? 0);
  const fixDep = Number(r.lab_fix_deposit ?? 0);
  if (disPerc > 0) return `${disPerc}% of total`;
  if (fixDep > 0) return `Fixed ₹${fmtMoney(fixDep)}`;
  return 'No discount';
};



// compute discount: prefer percentage if >0, else fixed deposit if >0, else 0
function computeDiscountAmount(row) {
  const total = Number(row.lab_total ?? 0);
  const disPer = Number(row.lab_dis_per ?? 0);
  const fixDep = Number(row.lab_fix_deposit ?? 0);

  if (!isNaN(disPer) && disPer > 0 && total > 0) {
    return (total * disPer) / 100;
  }
  if (!isNaN(fixDep) && fixDep > 0) {
    return fixDep;
  }
  return 0;
}
// fetch username using lab_due_pay_user id (from backend user table)
const fetchUserNameById = async (userId) => {
  try {
    if (!userId) return "N/A";
    const fd = new FormData();
    fd.append("user_id", String(userId));
    // You'll need an endpoint for this — most likely AppConst.getUserByIdUrl or similar
    // Example: AppConst.BASE_URL + "get_user_by_id"
    const res = await axios.post(AppConst.BASE_URL + AppConst.getUserByIdUrl, fd);
    if (res.data && res.data.status && res.data.user) {
      const u = res.data.user;
      return `${u.fname || ""} ${u.lname || ""}`.trim() || u.username || `User #${userId}`;
    }
    return `User #${userId}`;
  } catch (err) {
    console.error("fetchUserNameById error:", err);
    return `User #${userId}`;
  }
};

 {/* Totals Modal */}
<Modal show={showTotalsModal} onHide={() => setShowTotalsModal(false)} size="xl" centered>
  <Modal.Header closeButton>
    <Modal.Title>
      {totalsModalType === 'due' ? 'Patients with Due' :
       totalsModalType === 'paid' ? 'Patients with Paid Amount' :
       totalsModalType === 'discount' ? 'Patients with Discount' :
       'Patient List (Total Amount)'}
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
    {totalsModalList && totalsModalList.length ? (
      <div style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        <table className="table table-sm table-hover">
          <thead>
            <tr>
              <th style={{ width: 40 }}>#</th>
              <th>UHID</th>
              <th>Patient</th>
              <th style={{ minWidth: 260 }}>Tests</th>
              <th style={{ textAlign: 'right', width: 110 }}>Total</th>
              <th style={{ textAlign: 'right', width: 110 }}>Discount</th>
              <th style={{ textAlign: 'right', width: 110 }}>Final</th>
              <th style={{ textAlign: 'right', width: 110 }}>Paid</th>
              <th style={{ textAlign: 'right', width: 110 }}>Due</th>
              <th style={{ width: 210 }}>Actions</th>
            </tr>
          </thead>

          <tbody>
            {totalsModalList.map((r, idx) => (
              <tr key={r.lab_reg_id ?? idx}>
                <td>{idx + 1}</td>
                <td>{r.lab_reg_uhid || '-'}</td>
                <td>{`${(r.lab_reg_name_title || '').trim()} ${(r.lab_reg_name || '').trim()}`.trim() || '-'}</td>
                <td style={{ maxWidth: 520, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {r.displayTestNames || (Array.isArray(r.params) ? r.params.map(t => t.lab_item_test_name || t.name).join(' || ') : '-')}
                </td>

                <td style={{ textAlign: 'right' }}>{fmtMoney(r.lab_total)}</td>

                <td style={{ textAlign: 'right' }}>
                  <span title={discountSourceLabel(r)}>{fmtMoney(computeDiscountAmount(r))}</span>
                </td>

                <td style={{ textAlign: 'right' }}>{fmtMoney(r.lab_final_amt)}</td>
                <td style={{ textAlign: 'right' }}>{fmtMoney(r.lab_paid)}</td>
                <td style={{ textAlign: 'right' }}>{fmtMoney(r.lab_due)}</td>

                <td>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => {
                        // open view modal (fetches user-name if needed) then close totals modal
                        openViewModal(r);
                        setShowTotalsModal(false);
                      }}
                    >
                      View
                    </button>

                    <button
                      className="btn btn-sm btn-warning"
                      onClick={() => {
                        sessionStorage.setItem("lab_dt", JSON.stringify(r));
                        window.location.href = "/registrations";
                      }}
                    >
                      Edit
                    </button>

                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => {
                        if (!isAdmin) {
                          Swal.fire({ icon: "info", title: "Permission required", text: "Only admins can delete." });
                          return;
                        }
                        Swal.fire({
                          title: 'Are you sure?',
                          text: `Delete registration ${r.lab_reg_id || ''} ?`,
                          icon: 'warning',
                          showCancelButton: true,
                          confirmButtonText: 'Yes, delete'
                        }).then(result => {
                          if (result.isConfirmed) {
                            delItem(r);
                            // update modal list for immediate UI feedback
                            setTotalsModalList(prev => prev.filter(x => String(x.lab_reg_id) !== String(r.lab_reg_id)));
                          }
                        });
                      }}
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : (
      <div>No records found.</div>
    )}
  </Modal.Body>

  <Modal.Footer>
  <Button variant="secondary" onClick={() => setShowReportModal(false)}>
    Cancel
  </Button>
  
  {/* WhatsApp Notification Button */}
  <Button 
    variant="success" 
    onClick={handleSendWhatsApp}
    disabled={selectedTests.length === 0}
    style={{ display: 'flex', alignItems: 'center', gap: 6 }}
  >
    <i className="ri-whatsapp-line" style={{ fontSize: 18 }}></i>
    Send Notification
  </Button>
  
  {/* WhatsApp PDF Button */}
  <Button 
    variant="info" 
    onClick={handleSendLabPdfWhatsApp}
    disabled={selectedTests.length === 0}
    style={{ display: 'flex', alignItems: 'center', gap: 6 }}
  >
    <i className="ri-file-pdf-line" style={{ fontSize: 18 }}></i>
    Send PDF Report
  </Button>
  
  {/* Print Button */}
  <Button 
    variant="primary" 
    onClick={handlePrintClick}
    disabled={selectedTests.length === 0}
  >
    <i className="ri-printer-line me-2"></i>
    Print Selected ({selectedTests.length})
  </Button>
</Modal.Footer>
</Modal>

 
const openViewModal = async (row) => {
  const viewData = { ...row };

  // Fetch later paid user name if ID exists
  if (viewData.lab_due_pay_user) {
    const uname = await fetchUserNameById(viewData.lab_due_pay_user);
    viewData.lab_due_pay_user_name = uname;
  }

  setViewItem(viewData);
  setShowViewModal(true);
};

  
  
  {/* Hover-only view button: hidden normally, visible on row hover */}
<style>
{`
  /* Hide the View button by default */
  .rdt_TableRow .view-btn {
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s ease;
  }

  /* Show when row is hovered */
  .rdt_TableRow:hover .view-btn {
    opacity: 1;
    pointer-events: auto;
  }
`}
</style>


  const [formData, setFormData] = useState({
    cat_type: 'department',
    page_no: 0,
    l1: [],
    l11: [],
    l2: [],
    l3: [],
    departs: [],
    selItem: {},
    alertMsg: '',
    alertMsgTyp: '',
    search_key: '',
    from: today, // default to today
    to: today,   // default to today
    isAlert: false,
    test_report_datetime: '' // will be set on mount to formatted datetime
  });

  const [totals, setTotals] = useState({
    totalAmount: 0,
    discountAmount: 0,
    paidAmount: 0,
    dueAmount: 0,
    totalCharges: 0
  });

  const [ldata, setLdata] = useState(null);
  const [selItem, setSelItem] = useState(null);   // sample modal item (unchanged)
  const [payItem, setPayItem] = useState(null);
  const [editItem, setEditItem] = useState(null);
  
  
  
  
  const normalizeTest = (t = {}) => {
  // row identity — unique per test instance (used for checkboxes/selection)
  const rowId = String(t.lab_item_id ?? t.id ?? '');

  // MASTER test id — must come only from these two. NEVER lab_item_id.
  const testId = String(t.lab_item_test_id ?? t.test_id ?? '');

  const name = String(
    t.lab_item_test_name ?? t.test_name ?? t.name ?? ''
  ).trim();

  return {
    ...t,
    id: rowId || testId,
    lab_item_id: t.lab_item_id,
    lab_item_test_id: testId,   // ✅ preserved, not clobbered
    test_id: testId,            // ✅ keep master id explicit
    lab_item_test_name: t.lab_item_test_name ?? name,
    name
  };
};
  
  
const rowBelongsToLoggedDoctor = (row) => {
  // Build this doctor's name from session (fname + optional lname), trimmed & lowercased
  const myName = `${(ldata?.fname || '').trim()} ${(ldata?.lname || '').trim()}`
    .trim()
    .toLowerCase();
  if (!myName) return false;

  const ref = String(row.lab_reg_referral || '').trim().toLowerCase();
  if (!ref) return false;

  // exact match, or one contains the other (tolerates a "DR " prefix or trailing spaces)
  return ref === myName || ref.includes(myName) || myName.includes(ref);
};
  
  // init on mount
  // ✅ SINGLE, CONSOLIDATED INITIALIZATION EFFECT
useEffect(() => {
  console.log("🚀 Component mounted - starting initialization");
  
  // Get today's date in YYYY-MM-DD format
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  const todayStr = `${yyyy}-${mm}-${dd}`;
  
  console.log("📅 Today's date:", todayStr);

  // Load ldata from session
  const storedData = sessionStorage.getItem("ldata");
  if (storedData) {
    try {
      const parsed = JSON.parse(storedData);
      setLdata(parsed);
      console.log("👤 User data loaded:", parsed.fname, parsed.lname);
    } catch (e) {
      console.warn("❌ Failed to parse ldata", e);
    }
  }

  // Check if we're loading a single edit record
  const storedLabDt = sessionStorage.getItem("lab_dt");
  
  if (storedLabDt) {
    console.log("📝 Edit mode detected - loading single record");
    // Don't call initData - let the other useEffect handle this
    return;
  }

  // Normal list mode - set dates and load data
  console.log("📋 List mode - loading patient list for today");
  
  // Update state with today's dates
  setFormData(prev => ({ 
    ...prev, 
    from: todayStr, 
    to: todayStr 
  }));

  // ✅ CRITICAL: Use setTimeout to ensure state is set before API call
  // This prevents race condition where initData runs before state updates
  setTimeout(() => {
    console.log("🔄 Calling initData with dates:", todayStr);
    initData({ 
      from: todayStr, 
      to: todayStr, 
      search_key: "" 
    });
  }, 100); // Small delay ensures state is ready

  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []); // Empty dependency array - run once on mount
  // Add this after your other useEffect hooks, before the columns definition



// ✅ Helper to attach logged-in user info to any FormData
const attachUserInfo = (fd) => {
  try {
    const stored = sessionStorage.getItem("ldata");
    if (stored) {
      const u = JSON.parse(stored);
      fd.append('user_id',   u.user_id   || '');
      fd.append('user_name', `${u.fname || ''} ${u.lname || ''}`.trim());
      fd.append('user_role', u.role_id   || u.role_name || '');
    }
  } catch (e) {
    console.warn("attachUserInfo failed:", e);
  }
  return fd;
};

// ✅ AUTO-REFRESH: Refresh page every 5 minutes if no user activity
useEffect(() => {
  let activityTimer;
  let lastActivityTime = Date.now();
  const INACTIVITY_TIMEOUT = 5 * 60 * 1000; // 5 minutes in milliseconds

  // Function to reset activity timer
  const resetActivityTimer = () => {
    lastActivityTime = Date.now();
    
    // Clear existing timer
    if (activityTimer) {
      clearTimeout(activityTimer);
    }

    // Set new timer
    activityTimer = setTimeout(() => {
      const now = Date.now();
      const timeSinceLastActivity = now - lastActivityTime;

      // If truly inactive for 5 minutes, refresh the page
      if (timeSinceLastActivity >= INACTIVITY_TIMEOUT) {
        console.log("🔄 Auto-refreshing page due to inactivity...");
        
        // Option 1: Refresh entire page (full reload)
        window.location.reload();
        
        // Option 2: Just refresh data (uncomment if you prefer this)
        // const today = new Date().toISOString().split('T')[0];
        // initData({ from: today, to: today, search_key: "" });
      }
    }, INACTIVITY_TIMEOUT);
  };

  // Activity event listeners
  const activityEvents = [
    'mousedown',
    'mousemove', 
    'keypress',
    'scroll',
    'touchstart',
    'click'
  ];

  // Attach listeners
  activityEvents.forEach(event => {
    document.addEventListener(event, resetActivityTimer, true);
  });

  // Start initial timer
  resetActivityTimer();

  // Cleanup
  return () => {
    if (activityTimer) {
      clearTimeout(activityTimer);
    }
    activityEvents.forEach(event => {
      document.removeEventListener(event, resetActivityTimer, true);
    });
  };
}, []);
  
  useEffect(() => {
    const cleanup = () => {
      document.querySelectorAll('.modal-backdrop').forEach(n => n.remove());
      document.body.classList.remove('modal-open');
      document.querySelectorAll('.modal.show').forEach(m => m.classList.remove('show'));
    };

    cleanup();
    window.addEventListener('beforeunload', cleanup);
    return () => {
      window.removeEventListener('beforeunload', cleanup);
      cleanup();
    };
  }, []);

  const initData2 = async () => {
    const storedDataF = JSON.parse(sessionStorage.getItem("ldata") || "{}");
    setName(
      [storedDataF?.fname, storedDataF?.lname].filter(Boolean).join(" ")
    );
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) {
      try {
        const fd = new FormData();
        fd.append('cat_type', "department");
        fd.append('page_no', "none");
        fd.append('search_key', "");
        fd.append('par_by', "all");

        const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd);
        if (response.data.status && response.data.records) {
          setFormData(prev => ({
            ...prev,
            departs: response.data.records
          }));
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  useEffect(() => {
    initData2();
  }, []);

  const getTests = async (user_id) => {
    const fd1 = new FormData();
    fd1.append('page_no', "none");
    fd1.append('search_key', "");
    fd1.append('lab_item_user', user_id + "");
    try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.getLabRegListItmUrl, fd1, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (response.data.status && response.data.records) {
        setFormData(prev => ({
          ...prev,
          l1: response.data.records
        }));
      } else {
        setFormData(prev => ({ ...prev, l1: [] }));
      }
    } catch (error) {
      toast.error("Failed to fetch test data.");
    }
  };
  const canEditWithin24Hrs = (row) => {
    if (!row || !row.lab_reg_datetime) return true; // allow if no datetime
    const regDate = new Date(row.lab_reg_datetime);
    if (isNaN(regDate.getTime())) return true; // unknown format, default allow
    const diffMs = Date.now() - regDate.getTime();
    return diffMs < 20 * 24 * 60 * 60 * 1000; // true if less than 24 hours
  };
  
  // allow optional overrides: initData({ from, to, search_key })
// Replace the existing initData function with this updated version:
const initData = async (overrides = {}) => {
  try {
    const fd = new FormData();

    // Determine from/to using overrides first, then formData values
    const from = overrides.from !== undefined ? overrides.from : formData.from;
    const to = overrides.to !== undefined ? overrides.to : formData.to;
    const search_key = overrides.search_key !== undefined ? overrides.search_key : (formData.search_key || "");

    // ✅ IF SEARCH KEY EXISTS, IGNORE DATE FILTERING - fetch all data
    if (search_key && search_key.trim() !== "") {
      console.log("🔍 Search active - ignoring date filters, fetching all data");
      fd.append('page_no', 'none');
      fd.append('search_key', search_key.trim());
      fd.append('from', ""); // ✅ Empty dates = fetch all
      fd.append('to', "");
      fd.append('lab_reg_user', 'all');
    } else {
      // ✅ NO SEARCH KEY - apply date filtering normally
      console.log("📅 No search - applying date filters:", { from, to });
      fd.append('page_no', 'none');
      fd.append('search_key', "");
      fd.append('from', from ? (from + " 00:00:00") : "");
      fd.append('to', to ? (to + " 23:59:59") : "");
      fd.append('lab_reg_user', 'all');
    }

   



        // ✅ Send logged-in user identity so backend can restrict a doctor to their own referrals
        try {
          const stored = sessionStorage.getItem("ldata");
          if (stored) {
            const u = JSON.parse(stored);
            fd.append('logged_user_id',   u.user_id   || '');
            fd.append('logged_user_type', u.type      || '');
            fd.append('logged_role_id',   u.role_id   || '');
          }
        } catch (e) { /* ignore */ }
    const response = await axios.post(AppConst.BASE_URL + AppConst.getLabRegListUrl, fd);

    console.log("initData: response", response);
    if (response.data && response.data.status) {
      const records = response.data.records || [];
      setFormData(prev => ({ ...prev, l1: records }));
      if (response.data.refund_map) {
        setLabRefundMap(response.data.refund_map);
      }
    } else {
      console.warn("initData: response.status false or missing", response.data);
      setFormData(prev => ({ ...prev, l1: response.data?.records || [] }));
    }
  } catch (err) {
    console.error("initData error:", err);
    toast.error("Failed to load patient list. Check console/network.");
  }
};

  


  

  useEffect(() => {
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) {
      const parsed = JSON.parse(storedData);
      setLdata(parsed);
    }
  
    const storedLabDt = sessionStorage.getItem("lab_dt");
    if (storedLabDt) {
      try {
        const parsed = JSON.parse(storedLabDt);
        setEditItem(parsed); // if you have an edit state
  
        (async () => {
          // prefer existing params/tests in the stored object
          let items = parsed.params || parsed.tests || parsed.all_tests || [];
        
          // if nothing present, fetch from server using lab_reg_id
          if ((!items || items.length === 0) && parsed.lab_reg_id) {
            items = await fetchLabItemsByRegId(parsed.lab_reg_id);
          }
        
          // NORMALIZE each test: ensure stable id + name fields (used by UI)
          items = (items || []).map(it => {
            const n = normalizeTest(it); // normalizeTest defined earlier
            // make sure lab_item_test_name exists for legacy code
            if (!n.lab_item_test_name && n.name) n.lab_item_test_name = n.name;
            return n;
          });
        
          const normalizedRecord = {
            ...parsed,
            tests: items,
            params: items,
            all_tests: items,
            // use .name which normalizeTest created
            displayTestNames: items.length ? items.map(t => t.name).join(' || ') : (parsed.displayTestNames || '')
          };
        
          // Put only this record into list for the table (so UI shows the edited row)
          setFormData(prev => ({ ...prev, l1: [normalizedRecord] }));
        
          setSelectedUser(normalizedRecord);
        
          // Preselect tests by their IDs (so checkboxes are checked)
          const testIds = (normalizedRecord.tests || normalizedRecord.params || []).map(t => String(t.id));
          setSelectedTests(testIds);
        
          // Make report modal helpers aware of the tests (so labels show)
          setCurrentTests(items);
        
          setEditItem(normalizedRecord);
        })();
        
  
      } catch (e) {
        console.error("Failed to parse sessionStorage.lab_dt", e);
        // fallback: load normal list
        initData();
      }
      return; // don't call initData after loading a single edit record
    }
  
    // default behavior when NOT editing a single record
    initData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  

  useEffect(() => {
    if (resetTriggered) {
      initData();
      setResetTriggered(false);
    }
  }, [resetTriggered]);




// helper: fetch lab items for a registration id
// helper: fetch lab items for a registration id
const fetchLabItemsByRegId = async (labRegId) => {
  try {
    const fd = new FormData();
    fd.append('page_no', 'none');
    fd.append('lab_item_parent', String(labRegId));
    
    const res = await axios.post(AppConst.BASE_URL + AppConst.getLabRegListItmUrl, fd);
    
   if (res.data && res.data.status && Array.isArray(res.data.records)) {
  return res.data.records.map(rec => ({
    ...rec,
    test_id: rec.lab_item_test_id || rec.test_id,   // master test id
    lab_item_test_id: rec.lab_item_test_id,         // ✅ never fall back to lab_item_id
    lab_item_id: rec.lab_item_id,
    id: rec.lab_item_id || rec.lab_item_test_id,    // row identity for UI/checkboxes
    name: rec.lab_item_test_name || rec.test_name || rec.name
  }));
}
    
    return [];
  } catch (err) {
    console.error("fetchLabItemsByRegId error:", err);
    return [];
  }
};

// Ensure the full params (with result field) are available for a test object.
// It expects a test object that has some id: lab_item_test_id (preferred) or lab_item_id, test_id, etc.
const ensureTestHasParams = async (test) => {
  try {
    if (!test) return test;
    
    console.log("ensureTestHasParams called for:", test);
    
    // If params exist and already have data, keep as-is
    if (Array.isArray(test.params) && test.params.length > 0) {
      const hasData = test.params.some(p => 
        p.test_param_name && String(p.test_param_name).trim() !== ''
      );
      if (hasData) {
        console.log("✅ Test already has params:", test.lab_item_test_name || test.name);
        return test;
      }
    }

    // Get the MASTER test_id (not lab_item_id)
    const testId = getTestIdForParams(test);
    
    console.log("Fetching params with test_id:", testId, "for test:", test.lab_item_test_name || test.name);

    if (!testId) {
      console.warn("❌ No test ID found for:", test);
      return { ...test, params: [] };
    }

    const fd = new FormData();
    fd.append('page_no', 'none');
    fd.append('search_key', '');
    fd.append('test_id', String(testId)); // Use master test_id

    const resp = await axios.post(
      AppConst.BASE_URL + AppConst.getTestParamListUrl, 
      fd,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );

    console.log("API response:", resp.data);

    if (resp && resp.data && resp.data.status && Array.isArray(resp.data.records) && resp.data.records.length > 0) {
      const params = resp.data.records.map(p => ({
        ...p,
        result: p.result || p.test_result || p.lab_item_result || '',
        test_param_name: p.test_param_name || p.param_name || '',
        test_param_type: p.test_param_type || 'Text',
        test_range_type: p.test_range_type || '',
        test_param_from_range: p.test_param_from_range || '',
        test_param_to_range: p.test_param_to_range || '',
        test_param_method: p.test_param_method || '',
        test_sample_type: p.test_sample_type || test.test_sample_type || '',
        test_cat: p.test_cat || test.test_cat || ''
      }));

      console.log("✅ Loaded", params.length, "params for", test.lab_item_test_name || test.name);

      return {
        ...test,
        params,
        test_sample_type: params[0]?.test_sample_type || test.test_sample_type,
        test_cat: params[0]?.test_cat || test.test_cat,
        interpretation: test.interpretation || params[0]?.test_interpratation || params[0]?.test_interpretation || ''
      };
    }

    console.warn("❌ No params returned for test_id:", testId);
    return { ...test, params: [] };
  } catch (err) {
    console.error("❌ ensureTestHasParams error:", err);
    return { ...test, params: [] };
  }
};

const handlePatientSelect = async (item) => {
  setSearchKey(`${item.lab_reg_name} (${item.lab_reg_uhid})`);
  setShowSearchDropdown(false);

  const status = (item.lab_reg_status || '').toString().toLowerCase();
  if (status === 'pending' || status === 'sample not collected' || status === 'not collected') {
    Swal.fire({
      icon: 'warning',
      title: 'Sample not collected',
      text: 'This patient\'s sample is not yet collected.',
      confirmButtonText: 'OK'
    });
    setSelectedUser(item);
    setFormData(prev => ({ ...prev, test_id0: '', l11: [] }));
    return;
  }

  // Get tests for this patient
  const patientTests = formData.l1.filter(i => i.lab_item_parent === item.lab_item_parent);
  
  console.log("Patient tests:", patientTests);

  // Enrich each test with master test_id if missing
  const enrichedTests = patientTests.map(test => {
    // Make sure we have the master test_id
    const masterTestId = test.test_id || test.lab_item_test_id || test.id;
    
    return {
      ...test,
      test_id: masterTestId, // Store master test_id explicitly
      lab_item_test_id: test.lab_item_test_id || test.lab_item_id, // Registration-specific ID
      impression: '',
      notes: '',
      interpretation: (test.interpretation && String(test.interpretation).trim())
        ? test.interpretation
        : (test.params?.[0]?.test_interpratation || test.params?.[0]?.test_interpretation || '')
    };
  });

  console.log("Enriched tests:", enrichedTests);

  setFormData(prev => ({
    ...prev,
    test_id0: item.lab_item_parent,
    l11: enrichedTests
  }));

  setSelectedUser(item);
};
// when editing (navigated from list) sessionStorage.lab_dt contains the record

function formatDateTime(dtStr) {
  if (!dtStr) return "";
  try {
    // try Date parse first (works for many formats)
    let d = new Date(dtStr);
    if (isNaN(d.getTime())) {
      // fallback: replace space with 'T' (common server format "YYYY-MM-DD HH:mm:ss")
      const t = String(dtStr).trim().replace(" ", "T");
      d = new Date(t);
    }
    if (isNaN(d.getTime())) return String(dtStr);

    const dd = String(d.getDate()).padStart(2, "0");
    const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    const mon = months[d.getMonth()];
    const yyyy = d.getFullYear();

    // 12-hour time
    let hh = d.getHours();
    const ampm = hh >= 12 ? "PM" : "AM";
    hh = hh % 12;
    if (hh === 0) hh = 12;
    const mm = String(d.getMinutes()).padStart(2, "0");

    return `${dd}-${mon}-${yyyy} ${String(hh).padStart(2, "0")}:${mm} ${ampm}`;
  } catch (e) {
    return String(dtStr);
  }
}




  // Replace the existing makePayment function
const makePayment = (patient) => {
  try {
      setSelectedPaymentPatient(patient);
      setPaymentMode('');
      setPaymentAmount('');
      setPaymentReceivedBy(Name); // Auto-fill with current user
      setPaymentRemarks('');
      fetchPaymentHistory(patient.lab_reg_id); // Load payment history
      setShowPaymentModal(true);
  } catch (error) {
      console.error("makePayment error:", error);
  }
};
// Open refund modal directly from row (without going through payment modal)
const makeRefund = (patient) => {
  try {
    const paid = parseFloat(patient.lab_paid || 0);
    if (paid <= 0) {
      Swal.fire({
        icon: 'info',
        title: 'No Payment to Refund',
        text: 'This patient has no paid amount to refund.',
        confirmButtonColor: '#405189'
      });
      return;
    }
    
    setSelectedPaymentPatient(patient);
    setRefundAmount('');
    setRefundMode('');
    setRefundRemarks('');
    setRefundedBy(Name);
    fetchRefundHistory(patient.lab_reg_id);
    setShowRefundModal(true);
  } catch (error) {
    console.error("makeRefund error:", error);
  }
};
  const collectSamepl = (item) => {
    try {
      setSelItem(item);
      setSelectedUser(item);
      const testsArray = Array.isArray(item?.params) ? item.params : (item?.all_tests || []);
      setSelectedTests(
        testsArray.map(t => normalizeTest(t).id)
      );
      
    } catch (err) {
      console.error("collectSamepl error:", err);
    }
  };



  // ✅ NEW: Check if current user can access Report Entry (Admin=1 OR Pathologist=3 only)
const canAccessReportEntry = () => {
  const roleId = String(ldata?.role_id ?? '').trim();
  return roleId === '1' || roleId === '3';
};

// ✅ NEW: Navigate to Report Entry page with UHID pre-filled
const handleReportEntry = (row) => {
  // 1. Role check first
  if (!canAccessReportEntry()) {
    Swal.fire({
      icon: 'error',
      title: 'Access Denied',
      html: `
        <p>You do not have permission to access Report Entry.</p>
        <hr/>
        <p style="font-size: 13px; color: #666;">
          Only <strong>Admin</strong> or <strong>Pathologist</strong> users can enter reports.
        </p>
      `,
      confirmButtonColor: '#405189',
      confirmButtonText: 'OK'
    });
    return;
  }

  // 2. Validate UHID
  if (!row || !row.lab_reg_uhid) {
    toast.error("No UHID available for this patient");
    return;
  }

  // 3. Store prefill data for ReportEntry to pick up
  const reportEntryPrefill = {
    lab_reg_id: row.lab_reg_id,
    lab_reg_uhid: row.lab_reg_uhid,
    lab_reg_name: row.lab_reg_name,
    lab_reg_name_title: row.lab_reg_name_title || '',
    lab_item_parent: row.lab_reg_id,
    source: 'lab_registrations',
    timestamp: Date.now()
  };

  try {
    sessionStorage.setItem('report_entry_prefill', JSON.stringify(reportEntryPrefill));
  } catch (e) {
    console.error("sessionStorage error:", e);
    toast.error("Unable to open report entry");
    return;
  }

  // 4. Navigate — adjust path if yours is different
  navigate('/report_entry');
};
  // onUpNow (payment saving)
  const onUpNow = async (pid, total, dis, deposit, final, paid, due, lab_pay_mode = "", lab_due_pay_mode = "") => {
    try {
      if (!pid) {
        console.error("onUpNow missing pid:", pid);
        return;
      }
      const fd = new FormData();
      fd.append('lab_reg_id', String(pid));
      fd.append('lab_total', String(total || ""));
      fd.append('lab_dis_per', String(dis || ""));
      fd.append('lab_fix_deposit', String(deposit || ""));
      fd.append('lab_final_amt', String(final || ""));
      fd.append('lab_paid', String(paid || ""));
      fd.append('lab_due', String(due || ""));
      if (lab_pay_mode && lab_pay_mode.length > 0) {
        fd.append('lab_pay_mode', String(lab_pay_mode));
      }
      if (lab_due_pay_mode && lab_due_pay_mode.length > 0) {
        fd.append('lab_due_pay_mode', String(lab_due_pay_mode));
      }

      const response = await axios.post(AppConst.BASE_URL + AppConst.upPayUrl, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      console.log("upPay response", response?.data);

      if (response && response.data && response.data.status) {
        document.getElementById("dfgdfv")?.click?.();
        await initData();
        Swal.fire({ icon: "success", title: "Payment saved", timer: 1200, showConfirmButton: false });
      } else {
        const msg = response?.data?.message || "Failed to save payment";
        Swal.fire({ icon: "error", title: "Save failed", text: msg });
        console.error("save failed", response?.data);
      }
    } catch (err) {
      console.error("Axios error upPayUrl:", err);
      Swal.fire({ icon: "error", title: "Server error", text: "Could not save payment. Check network or server logs." });
    }
  };

  const onUpNow1 = async (id, sample_type, sample_qty, cont_type, sample_cndi) => {
    try {
      if (!selItem) return;

      const fd = new FormData();
      fd.append('lab_reg_id', String(id));
      fd.append('sample_type', String(sample_type));
      fd.append('sample_qty', String(sample_qty));
      fd.append('cont_type', String(cont_type));
      fd.append('sample_cndi', String(sample_cndi));

      try {
        const response = await axios.post(AppConst.BASE_URL + AppConst.upSampleUrl, fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        if (response.data.status) {
          setSelItem(null);

          setFormData(prev => {
            const newL1 = (prev.l1 || []).map(x => {
              if (String(x.lab_reg_id) === String(id)) {
                return { ...x, lab_reg_status: 'Sample Collected' };
              }
              return x;
            });
            return { ...prev, l1: newL1 };
          });

          setSelItem(prev => prev && String(prev.lab_reg_id) === String(id) ? { ...prev, lab_reg_status: 'Sample Collected' } : prev);

          Swal.fire({
            title: "Success!",
            text: "Sample collected successfully.",
            icon: "success",
            timer: 1500,
            showConfirmButton: false,
          });
        } else {
          toast.error(response.data?.message || "Failed to update sample");
        }
      } catch (error) {
        console.error("Server error updating sample:", error);
        toast.error("Server error while updating sample");
      }
    } catch (error) {
      console.error("onUpNow1 error:", error);
    }
  };

  // handlers / helpers
  // Replace the existing handleChange function with this:
// Replace the existing handleChange function with this:
const handleChange = (e) => {
  const { name, value } = e.target;

  setFormData(prev => {
    const updated = { ...prev, [name]: value };
    
    // ✅ If search_key changed, fetch immediately with new search (ignoring dates)
    if (name === 'search_key') {
      setTimeout(() => {
        initData({ 
          from: prev.from,
          to: prev.to,
          search_key: value 
        });
      }, 0);
    }
    
    // ✅ If date fields changed, immediately fetch with new dates
    if (name === 'from' || name === 'to') {
      setTimeout(() => {
        initData({ 
          from: name === 'from' ? value : prev.from,
          to: name === 'to' ? value : prev.to,
          search_key: prev.search_key 
        });
      }, 0);
    }
    
    return updated;
  });
};


  const delItem = async (editItem) => {
    const fd = new FormData();
    fd.append('lab_reg_id', editItem.lab_reg_id + "");
    attachUserInfo(fd); 
    try {
      //const response = await axios.post(AppConst.BASE_URL + AppConst.delLabRegUrl, fd, {

      const response = await axios.post(AppConst.BASE_URL + AppConst.deleteLabRegUrl, fd, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      if (response.data.status) {
        initData();
      }
    } catch (error) {
      console.error("delItem error", error);
    }
  };

  const get_tst_name = (tests) => {
    if (!Array.isArray(tests) || !tests.length) return '';
    return tests.map(t => normalizeTest(t).name).join(' || ');
  };
  

  const fetchSignConfigData = async () => {
    try {
      let allSignData = {};
      let allPreviews = {};

      await Promise.all(
        formData.departs.map(async (dep) => {
          const fd = new FormData();
          fd.append('sign_department', dep.cat_id + "");
          const res = await axios.post(AppConst.BASE_URL + AppConst.getSignByDepartUrl, fd);
          if (res.data.status && res.data.sign_dt) {
            allSignData[dep.cat_id] = res.data.sign_dt;
            allPreviews[dep.cat_id] = {
              tech: res.data.sign_dt.sign_tech_sign ? AppConst.BASE_URL + res.data.sign_dt.sign_tech_sign : null,
              doc: res.data.sign_dt.sign_doc_sign ? AppConst.BASE_URL + res.data.sign_dt.sign_doc_sign : null
            };
          }
        })
      );

      setFormData(prev => ({
        ...prev,
        selItem: allSignData
      }));
    } catch (error) {
      console.error(error);
    }
  };

  const fetchConfigData = async () => {
    try {
      const res = await axios.post(
        `${AppConst.BASE_URL + AppConst.getconfig}?config_type=lab`
      );

      if (res.data.status) {
        const data = res.data;
        setImage(data.header_logo);
        setWatermarkImage(data.logo || '');
        setFooterImage(data.footer_logo || '');
      }
    } catch (err) {
      console.error("Error fetching config:", err);
    }
  };

  useEffect(() => {
    fetchConfigData();
    fetchSignConfigData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTests]);

  const imageUrlToBase64 = async (url) => {
    if (!url) {
      console.error("imageUrlToBase64: Provided URL is empty or invalid.");
      return null;
    }
    try {
      const response = await fetch(url, { cache: 'no-cache' });
      if (!response.ok) {
        console.error(`Failed to fetch image. URL: ${url}, Status: ${response.status} ${response.statusText}`);
        return null;
      }
      const blob = await response.blob();
      if (!blob.type.startsWith('image/')) {
        console.error(`The URL did not point to an image. URL: ${url}, MIME Type: ${blob.type}`);
        return null;
      }
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = (error) => {
          console.error("FileReader error:", error);
          reject(error);
        };
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("Error fetching or converting image. This might be a CORS issue.", { url, error });
      return null;
    }
  };

  // ---- PDF generation helpers (kept from your code, small refactors) ----
  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      return `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
    } catch (e) {
      return dateString;
    }
  };

// compute discount: prefer lab_dis_per % first if >0, else lab_fix_deposit, else 0
const computeDiscount = (row) => {
  const labTotal = Number(row.lab_total ?? 0);
  const disPerc = Number(row.lab_dis_per ?? 0);
  const fixDep = Number(row.lab_fix_deposit ?? 0);

  if (!isNaN(disPerc) && disPerc > 0) {
    return Number((labTotal * disPerc) / 100);
  }
  if (!isNaN(fixDep) && fixDep > 0) {
    return fixDep;
  }
  return 0;
};

function fmtMoney(v) {
  const n = Number(v ?? 0);
  if (isNaN(n)) return "0.00";
  return n.toFixed(2);
}



  const amountInWords = (amount) => {
    const num = parseFloat(amount);
    if (isNaN(num) || num === 0) return 'Zero';
    const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    const convertLessThanThousand = (n) => {
      if (n === 0) return '';
      let res = '';
      const hundreds = Math.floor(n / 100);
      if (hundreds > 0) {
        res += units[hundreds] + ' Hundred ';
        n %= 100;
      }
      if (n > 0) {
        if (res !== '') res += 'and ';
        if (n < 10) {
          res += units[n];
        } else if (n < 20) {
          res += teens[n - 10];
        } else {
          res += tens[Math.floor(n / 10)];
          if (n % 10 > 0) {
            res += ' ' + units[n % 10];
          }
        }
      }
      return res.trim();
    };
    let result = '';
    let n = num;
    const crores = Math.floor(n / 10000000);
    if (crores > 0) {
      result += convertLessThanThousand(crores) + ' Crore ';
      n %= 10000000;
    }
    const lakhs = Math.floor(n / 100000);
    if (lakhs > 0) {
      result += convertLessThanThousand(lakhs) + ' Lakh ';
      n %= 100000;
    }
    const thousands = Math.floor(n / 1000);
    if (thousands > 0) {
      result += convertLessThanThousand(thousands) + ' Thousand ';
      n %= 1000;
    }
    result += convertLessThanThousand(n);
    return result.trim();
  };
// ------------------ INSERT: generatePDF (Invoice / single-patient) ------------------
// Place this after helpers (imageUrlToBase64, formatDate, amountInWords) and before any calls.
const generatePDF = async (headerOption = 'with', patientData = {}) => {
  try {
    const patient = patientData || selectedUser || {};
    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth  = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const HALF = pageHeight / 2;               // patient copy lives in the top half
    const HEADER_IMG_H = 22;

    const safeNum = v => (v === undefined || v === null || isNaN(Number(v))) ? "0.00" : Number(v).toFixed(2);

    // ── Header image (only if "with") ──
    let y = 6;
    if (headerOption === 'with' && image) {
      try {
        const headerBase64 = await imageUrlToBase64(image);
        if (headerBase64) { doc.addImage(headerBase64, "PNG", 0, 0, pageWidth, HEADER_IMG_H); y = HEADER_IMG_H + 2; }
      } catch (e) { console.warn("generatePDF header failed", e); }
    }

    // ── Copy title ──
    doc.setFontSize(10).setFont('helvetica', 'bold').setTextColor(0, 0, 0);
    doc.text('PATIENT COPY', pageWidth / 2, y + 3, { align: 'center' });
    y += 6;

    // ── Patient details box ──
    autoTable(doc, {
      startY: y,
      body: [[
        `UHID : ${patient.lab_reg_uhid || 'N/A'}\n` +
        `Reg No : 00${patient.lab_reg_id || 'N/A'}\n` +
        `Patient : ${patient.lab_reg_name_title || ''} ${patient.lab_reg_name || 'N/A'}\n` +
        `Reg Date : ${formatDate(patient.lab_reg_date)}`,
        `Address : ${patient.lab_reg_address || 'N/A'}\n` +
        `Mobile : ${patient.lab_reg_mobile || 'N/A'}`,
        `Age : ${getAgeDisplay(patient)}\n` +
        `Gender : ${patient.lab_reg_gender || 'N/A'}\n` +
        `Ref. Doctor : ${patient.lab_reg_referral || 'N/A'}`
      ]],
      theme: "grid",
      styles: { fontSize: 7.5, cellPadding: 1.5, valign: "top", textColor: [0,0,0], lineColor: [0,0,0], lineWidth: 0.1 },
      margin: { left: 8, right: 8 },
      columnStyles: { 0: { cellWidth: 60 }, 1: { cellWidth: 60 }, 2: { cellWidth: 70 } }
    });
    y = (doc.lastAutoTable && doc.lastAutoTable.finalY) ? doc.lastAutoTable.finalY + 3 : y + 20;

    // ── Tests table ──
    const testsArr = Array.isArray(patient.params) ? patient.params
                    : (Array.isArray(patient.all_tests) ? patient.all_tests : []);
    const testsBody = (testsArr.length > 0)
      ? testsArr.map((t, idx) => ([
          idx + 1,
          t.lab_item_test_name || t.test_name || t.name || '-',
          safeNum(t.lab_item_test_price || t.test_price || 0),
          safeNum(t.lab_item_total || t.lab_item_test_price || t.test_price || 0)
        ]))
      : [[1, '-', '0.00', '0.00']];

    autoTable(doc, {
      startY: y,
      head: [["Sl.", "Test Name", "Amount", "Final"]],
      body: testsBody,
      theme: "grid",
      headStyles: { fillColor: [255,255,255], textColor: 0, fontStyle: 'bold', fontSize: 7.5 },
      bodyStyles: { fontSize: 7.5, textColor: 0 },
      styles: { cellPadding: 1, lineWidth: 0.1, lineColor: [0,0,0] },
      margin: { left: 8, right: 8 },
      columnStyles: { 0:{cellWidth:12,halign:"center"}, 1:{cellWidth:118}, 2:{cellWidth:30,halign:"right"}, 3:{cellWidth:30,halign:"right"} }
    });
    y = (doc.lastAutoTable && doc.lastAutoTable.finalY) ? doc.lastAutoTable.finalY + 3 : y + 20;

    // ── Amount summary (right aligned) ──
    const labelX = pageWidth - 68, valueX = pageWidth - 10, gap = 4;
    doc.setFont("helvetica", "bold").setFontSize(7.5);
    const discountToShow = (patient.lab_dis_per && Number(patient.lab_dis_per) > 0)
      ? ((Number(patient.lab_total || 0) * Number(patient.lab_dis_per || 0)) / 100).toFixed(2)
      : (patient.lab_fix_deposit ? Number(patient.lab_fix_deposit).toFixed(2) : "0.00");

    const pl = (label, value, off) => { doc.text(label, labelX, y+off); doc.text(value, valueX, y+off, null, null, "right"); };
    pl("Total",    safeNum(patient.lab_total),     0);
    pl("Discount", discountToShow,                 gap);
    pl("Final",    safeNum(patient.lab_final_amt), gap*2);
    pl("Paid",     safeNum(patient.lab_paid),      gap*3);
    pl("Due",      safeNum(patient.lab_due),       gap*4);

    // ── Amount in words ──
    const wordsY = y + gap*4 + 5;
    doc.setFontSize(7).setFont("helvetica", "bold");
    doc.text(`IN WORDS: ${amountInWords(patient.lab_final_amt)} only`.toUpperCase(), 8, wordsY);
    y = wordsY + 3;

    // ── QR + prepared by + signature ──
    try {
      const qrText = `UHID: ${patient.lab_reg_uhid || 'N/A'}\nName: ${patient.lab_reg_name || 'N/A'}`;
      const qr = await QRCode.toDataURL(qrText, { width: 80 });
      doc.addImage(qr, "PNG", 8, y, 14, 14);
    } catch (e) { console.warn("generatePDF QR failed", e); }
    doc.setFontSize(7).setFont("helvetica", "normal");
    doc.text(`Prepared By: ${Name}`, 26, y + 8);
    doc.text("Authorized Signature", pageWidth - 40, y + 8, { align: "right" });

    // keep everything inside the top half of A4 (guard note)
    if (y + 16 > HALF) console.warn("Patient copy content exceeded half-A4 height");

    const pdfBlobUrl = doc.output("bloburl");
    window.open(pdfBlobUrl, "_blank");
  } catch (err) {
    console.error("generatePDF error:", err);
    Swal.fire({ icon: "error", title: "PDF Error", text: "Could not generate invoice PDF." });
  }
};
// ------------------ END: generatePDF ------------------

  const handleGeneratePdf = (patient) => {
    setSelectedUser(patient);
    generatePDF(patient, headerType === "With Header" ? 'with' : 'without');
  };

  // --- robust helper functions for creating report PDF ---
  const safeRect = (doc, xRaw, yRaw, wRaw, hRaw) => {
    const x = Number(xRaw), y = Number(yRaw), w = Number(wRaw), h = Number(hRaw);
    const ok = [x, y, w, h].every(v => Number.isFinite(v));
    if (ok) {
      doc.setDrawColor(0, 0, 0);
      doc.setLineWidth(0.2);
      doc.rect(x, y, w, h);
    } else {
      console.warn("safeRect: skipping rect due to invalid args", { xRaw, yRaw, wRaw, hRaw, parsed: { x, y, w, h } });
    }
  };
function formatDateTime(dtStr) {
  if (!dtStr) return "";
  try {
    let d = new Date(dtStr);
    if (isNaN(d.getTime())) {
      d = new Date(String(dtStr).trim().replace(" ", "T"));
    }
    if (isNaN(d.getTime())) return String(dtStr);

    const dd = String(d.getDate()).padStart(2, "0");
    const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    const mon = months[d.getMonth()];
    const yyyy = d.getFullYear();

    let hh = d.getHours();
    const ampm = hh >= 12 ? "PM" : "AM";
    hh = hh % 12 || 12;
    const mm = String(d.getMinutes()).padStart(2, "0");

    return `${dd}-${mon}-${yyyy} ${String(hh).padStart(2, "0")}:${mm} ${ampm}`;
  } catch (e) {
    return String(dtStr);
  }
}
 const printPatientDetails = async (doc, patient = {}, startY = 40) => {
  try {
    if (!doc || !doc.internal) {
      console.error("printPatientDetails: invalid doc", doc);
      return Number(startY) || 12;
    }
    startY = Number(startY);
    if (!isFinite(startY)) startY = 40;

    // page width (jsPDF version-safe)
    let pageWidthRaw;
    try {
      pageWidthRaw = typeof doc.internal.pageSize.getWidth === 'function'
        ? doc.internal.pageSize.getWidth()
        : doc.internal.pageSize.width;
    } catch (e) {
      pageWidthRaw = doc.internal.pageSize && doc.internal.pageSize.width;
    }
    const PAGE_WIDTH = isFinite(Number(pageWidthRaw)) ? Number(pageWidthRaw) : 210;

    // ---- box geometry ----
    const boxLeft   = 10;
    const boxTop    = startY - 2;
    const boxWidth  = PAGE_WIDTH - boxLeft * 2;
    const boxHeight = 26;

    // 1) outer box
    drawOutline(doc, THEME.outline.patientBox, boxLeft, boxTop, boxWidth, boxHeight);

    // 2) QR (inside the box, right side)
    if (THEME.qr.show) {
  try {
    const qrSize   = Number(THEME.qr.size);
    const gapRight = Number(THEME.qr.gapRight ?? 3);
    const gapTop   = Number(THEME.qr.gapTop   ?? 0);

    const qrX = boxLeft + boxWidth - qrSize - gapRight;
    const qrY = boxTop + (boxHeight - qrSize) / 2 + gapTop;

    const qrDataUrl = await makeQr(patient);
    if (qrDataUrl) doc.addImage(qrDataUrl, "PNG", qrX, qrY, qrSize, qrSize);
  } catch (e) { console.warn("QR failed", e); }
}

    // 3) values
    const dateParts = String(patient.lab_reg_date || "").split("-");
    const formattedDate = (dateParts.length >= 3)
      ? `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`
      : (patient.lab_reg_date || "");

    const reportedOn = formatDateTime(
      formData?.test_report_datetime || new Date().toISOString()
    );

    const sampleCollectedOn = patient.lab_reg_sample_datetime
      ? formatDateTime(patient.lab_reg_sample_datetime)
      : 'N/A';

    const titlePrefix = patient.lab_reg_name_title
      ? String(patient.lab_reg_name_title).trim() + ' '
      : '';

    // 4) text columns
    const leftColLabel  = boxLeft + 4;
    const leftColValue  = leftColLabel + 36;
    const rightColLabel = boxLeft + Math.round(boxWidth * 0.5) + 4;
    const rightColValue = rightColLabel + 36;

    let yPos = boxTop + 5;
    doc.setFontSize(THEME.font.patient);
    doc.setTextColor(0, 0, 0);

    doc.setFont('helvetica', 'bold');   doc.text("UHID", leftColLabel, yPos);
    doc.setFont('helvetica', 'normal'); doc.text(`: ${patient.lab_reg_uhid || ''}`, leftColValue, yPos);
    doc.setFont('helvetica', 'bold');   doc.text("Patient ID", rightColLabel, yPos);
    doc.setFont('helvetica', 'normal'); doc.text(`: 00${patient.lab_reg_id || ''}`, rightColValue, yPos);
    yPos += 4;

    doc.setFont('helvetica', 'bold');   doc.text("Patient Name", leftColLabel, yPos);
    doc.setFont('helvetica', 'normal'); doc.text(`: ${titlePrefix}${patient.lab_reg_name || ''}`, leftColValue, yPos);
    doc.setFont('helvetica', 'bold');   doc.text("Registered On", rightColLabel, yPos);
    doc.setFont('helvetica', 'normal'); doc.text(`: ${formattedDate}`, rightColValue, yPos);
    yPos += 4;

    doc.setFont('helvetica', 'bold');   doc.text("Age / Gender", leftColLabel, yPos);
    doc.setFont('helvetica', 'normal'); doc.text(`: ${getAgeDisplay(patient)} / ${patient.lab_reg_gender || ''}`, leftColValue, yPos);
    doc.setFont('helvetica', 'bold');   doc.text("Collected At", rightColLabel, yPos);
    doc.setFont('helvetica', 'normal'); doc.text(`: ${patient.lab_collected_at || ''}`, rightColValue, yPos);
    yPos += 4;

    doc.setFont('helvetica', 'bold');   doc.text("Referred By", leftColLabel, yPos);
    doc.setFont('helvetica', 'normal'); doc.text(`: ${patient.lab_reg_referral || 'N/A'}`, leftColValue, yPos);
    doc.setFont('helvetica', 'bold');   doc.text("Sample Collected By", rightColLabel, yPos);
    doc.setFont('helvetica', 'normal'); doc.text(`: ${Name || ''}`, rightColValue, yPos);
    yPos += 4;

    doc.setFont('helvetica', 'bold');   doc.text("Sample Collection", leftColLabel, yPos);
    doc.setFont('helvetica', 'normal'); doc.text(`: ${sampleCollectedOn}`, leftColValue, yPos);
    doc.setFont('helvetica', 'bold');   doc.text("Reported On", rightColLabel, yPos);
    doc.setFont('helvetica', 'normal'); doc.text(`: ${reportedOn}`, rightColValue, yPos);

    // 5) barcode BELOW the box — and only now do we return
    let afterBox = boxTop + boxHeight;

    if (THEME.barcode.show) {
      const bcUrl = makeBarcode(patient.lab_reg_uhid);
      if (bcUrl) {
        const bw = Number(THEME.barcode.width);
        const bh = Number(THEME.barcode.height);
        const bx = boxLeft + boxWidth - bw;
        const by = afterBox + Number(THEME.barcode.gapTop);

        doc.addImage(bcUrl, 'PNG', bx, by, bw, bh);
        afterBox = by + bh;

        if (THEME.barcode.showText) {
          doc.setFontSize(THEME.font.barcodeText)
             .setFont('helvetica', 'normal')
             .setTextColor(0, 0, 0);
          doc.text(String(patient.lab_reg_uhid || ''), bx + bw, by + bh + 3, { align: 'right' });
          afterBox += 3;
        }
      }
    }

    return afterBox + 6;
  } catch (err) {
    console.error("printPatientDetails FAILED:", err);
    return Number(startY) + 9;
  }
};

  async function addSignatures(doc, signData) {
    const finalY = doc.internal.pageSize.getHeight() - 45;
    if (!signData) return;

    if (signData.sign_tech_sign) {
      try {
        const techSignBase64 = await imageUrlToBase64(AppConst.BASE_URL + signData.sign_tech_sign);
        if (techSignBase64) {
          doc.addImage(techSignBase64, 'PNG', 14, finalY, 30, 15);
        }
      } catch (e) {
        console.warn("addSignatures tech image failed", e);
      }
      if (signData.sign_tech_name) {
        const techName = signData.sign_tech_name || '';
        const techId = signData?.sign_tech_id ? ` (${signData.sign_tech_id})` : '';
        doc.setFontSize(9).setFont('helvetica', 'normal').text(`${techName}${techId}`, 14, finalY + 20);
        doc.setFontSize(9).setFont('helvetica', 'bold').text("Lab Technician", 14, finalY + 24);
      }
    }

    if (signData.sign_doc_sign || signData.sign_doc_name) {
      if (signData.sign_doc_sign) {
        try {
          const docSignBase64 = await imageUrlToBase64(AppConst.BASE_URL + signData.sign_doc_sign);
          if (docSignBase64) {
            doc.addImage(docSignBase64, 'PNG', 166, finalY, 30, 15);
          }
        } catch (e) {
          console.warn("addSignatures doc image failed", e);
        }
      }
      if (signData.sign_doc_name) {
        const docName = signData.sign_doc_name || '';
        const docId = signData?.sign_doc_id ? ` (${signData.sign_doc_id})` : '';
        doc.setFontSize(11).setFont('helvetica', 'bold').text(`${docName}${docId}`, 196, finalY + 20, { align: 'right' });
        const designation = (signData.sign_department === '60') ? "Consultant" : "Consultant Pathologist";
        doc.setFontSize(9).setFont('helvetica', 'bold').text(designation, 196, finalY + 24, { align: 'right' });
      }
    }
  }

  const formatCellValue = (htmlString) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;
    const table = tempDiv.querySelector("table");
    if (table) {
      let rows = [];
      for (const tr of table.querySelectorAll("tr")) {
        let cells = [];
        for (const td of tr.querySelectorAll("td")) {
          cells.push(td.innerText.trim());
        }
        rows.push(cells.join(" | "));
      }
      return rows.join("\n");
    }
    return tempDiv.innerText.trim();
  };

  const drawHtmlContent = async (doc, htmlString, initialX, initialY, options) => {
    const { maxWidth, addNewPage, pageHeight, pageBuffer } = options;
    let x = initialX;
    let y = initialY;
    const lineSpacing = 5;
    const styleStack = [{ font: 'helvetica', style: 'normal', size: 9 }];
    const applyStyle = () => {
      const currentStyle = styleStack[styleStack.length - 1];
      doc.setFontSize(currentStyle.size);
      doc.setFont(currentStyle.font, currentStyle.style);
    };
    const parseNodes = async (nodes) => {
      for (const node of Array.from(nodes)) {
        if (y > pageHeight - pageBuffer) {
          y = await addNewPage();
          x = initialX;
        }
        if (node.nodeType === Node.TEXT_NODE) {
          let text = node.nodeValue.replace(/\s+/g, ' ');
          if (!text) continue;
          const words = text.split(' ');
          for (let i = 0; i < words.length; i++) {
            const word = words[i];
            if (!word) continue;
            const wordWidth = doc.getTextWidth(word);
            if (x > initialX && x + wordWidth > initialX + maxWidth) {
              x = initialX;
              y += lineSpacing;
              if (y > pageHeight - pageBuffer) {
                y = await addNewPage();
                x = initialX;
              }
            }
            applyStyle();
            doc.text(word, x, y);
            x += wordWidth + doc.getTextWidth(' ');
          }
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          const tagName = node.tagName.toUpperCase();
          let newStyle = { ...styleStack[styleStack.length - 1] };
          let isBlock = false;
          switch (tagName) {
            case 'STRONG':
            case 'B':
              newStyle.style = 'bold';
              break;
            case 'P':
            case 'DIV':
              if (x > initialX) {
                x = initialX;
                y += lineSpacing * 1.5;
              }
              isBlock = true;
              break;
            case 'BR':
              x = initialX;
              y += lineSpacing;
              isBlock = true;
              break;
          }
          styleStack.push(newStyle);
          await parseNodes(node.childNodes);
          styleStack.pop();
          if (isBlock && node.nextSibling) {
            if (x > initialX) {
              x = initialX;
              y += lineSpacing;
            }
          }
        }
      }
    };
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString.replace(/&nbsp;/g, ' ').trim();
    await parseNodes(tempDiv.childNodes);
    return y + lineSpacing / 2;
  };

  const get_param_val = (tmp) => {
    if (!tmp) return "";
  
    const type = (tmp.test_param_type || "").trim();
  
    // Numeric -> show "from - to" but only if either exists
    if (type === "Numeric") {
      const from = tmp.test_param_from_range ?? "";
      const to = tmp.test_param_to_range ?? "";
      if (from === "" && to === "") return "";
      if (from !== "" && to !== "") return `${from} - ${to}`;
      if (from !== "") return `${from}`;
      return `${to}`;
    }
  
    // Boolean -> prefer server-provided labels, otherwise default to Yes / No
    if (type === "Boolean") {
      return tmp.test_param_from_range || "Yes / No";
    }
  
    // Editor / Text / other types -> show whatever is present, otherwise empty
    return tmp.test_param_from_range || "";
  };

  const get_param_val1 = (tmp) => {
    if (tmp.test_param_type === "Numeric") return 1;
    if (tmp.test_param_type === "Boolean") return 2;
    return 3;
  };



// ✅ Increase space after bordered sections
const drawBorderedSection = async (doc, title, htmlContent, yPos, addNewPage, pageHeight, pageBuffer) => {
  if (!htmlContent || !String(htmlContent).trim()) return yPos;
  yPos = Number(yPos) || 0;

  const boxLeft = 14;
  const pw = doc.internal.pageSize.getWidth ? doc.internal.pageSize.getWidth() : doc.internal.pageSize.width;
  const boxWidth = pw - boxLeft * 2;

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = String(htmlContent).trim();
  const plainText = tempDiv.innerText.replace(/\u00A0/g, ' ').trim();
  const hasTable = !!tempDiv.querySelector('table');
  if (!plainText && !hasTable) return yPos;

  const startPage = doc.internal.getNumberOfPages();
  const startY = yPos;

  if (yPos + 12 > pageHeight - pageBuffer) yPos = await addNewPage();

  if (title) {
    doc.setFontSize(THEME.font.sectionTitle)
       .setFont('helvetica', 'bold')
       .setTextColor(...THEME.headerTxt);
    doc.text(String(title), boxLeft + 2, yPos + 5);
    doc.setTextColor(0, 0, 0);
    yPos += 11;
  }

  // ✅ walk children — tables go to autoTable, everything else to drawHtmlContent
  const nodes = Array.from(tempDiv.childNodes || []).filter(n => {
    if (n.nodeType === 3) return n.nodeValue.replace(/\u00A0/g, ' ').trim() !== '';
    if (n.nodeType === 1) {
      if (n.querySelector && n.querySelector('table')) return true;
      return (n.innerText || '').replace(/\u00A0/g, ' ').trim() !== '';
    }
    return false;
  });

  for (const node of nodes) {
    if (yPos + 8 > pageHeight - pageBuffer) yPos = await addNewPage();

    let tableEl = null;
    if (node.nodeType === 1) {
      tableEl = node.tagName.toUpperCase() === 'TABLE'
        ? node
        : (node.querySelector ? node.querySelector('table') : null);
    }

    if (tableEl) {
      if (yPos + 12 > pageHeight - pageBuffer) yPos = await addNewPage();
      try {
        autoTable(doc, {
          startY: yPos,
          html: tableEl,
          theme: 'grid',
          styles: {
            fontSize: THEME.font.tableBody, cellPadding: 2, valign: 'middle',
            textColor: [0, 0, 0], lineColor: THEME.border, lineWidth: 0.2
          },
          headStyles: {
            fontSize: THEME.font.tableHead, textColor: THEME.headerTxt,
            fillColor: THEME.headerBg, fontStyle: 'bold'
          },
          margin: { left: boxLeft + 2, right: boxLeft + 2 }
        });
        yPos = doc.lastAutoTable ? doc.lastAutoTable.finalY + 4 : yPos + 17;
      } catch (err) {
        console.warn('interp table render failed', err);
      }

      // render any non-table text that was wrapped around the table
      if (node !== tableEl) {
        const clone = node.cloneNode(true);
        const inner = clone.querySelector('table');
        if (inner) inner.remove();
        const rest = clone.innerHTML;
        if (rest && rest.trim()) {
          yPos = await drawHtmlContent(doc, rest, boxLeft + 2, yPos, {
            maxWidth: boxWidth - 4, addNewPage, pageHeight, pageBuffer
          });
          yPos += 3;
        }
      }
    } else {
      const chunk = node.outerHTML !== undefined ? node.outerHTML : node.nodeValue;
      if (!chunk || !String(chunk).trim()) continue;
      yPos = await drawHtmlContent(doc, chunk, boxLeft + 2, yPos, {
        maxWidth: boxWidth - 4, addNewPage, pageHeight, pageBuffer
      });
      yPos += 3;
    }
  }

  // border only if it didn't spill onto a new page
  if (doc.internal.getNumberOfPages() === startPage) {
    drawOutline(doc, THEME.outline.interpBox, boxLeft, startY, boxWidth, Math.max(10, yPos - startY));
  }

  yPos += 8;
  return yPos;
};
// returns formatted age with plural 's' when >1, or 'N/A' if all zero
const getAgeDisplay = (p) => {
  if (!p) return 'N/A';
  const y = Number(p.lab_reg_age_year || 0);
  const m = Number(p.lab_reg_age_month || 0);
  const d = Number(p.lab_reg_age_day || 0);

  if (y === 0 && m === 0 && d === 0) return 'N/A';

  const parts = [];
  if (y > 0) parts.push(`${y}Y${y > 1 ? 's' : ''}`);
  if (m > 0) parts.push(`${m}M${m > 1 ? 's' : ''}`);
  if (d > 0) parts.push(`${d}D${d > 1 ? 's' : ''}`);

  return parts.join(' ');
};



  // REPLACE generatePdfForTests with this improved version
// REPLACE the entire generatePdfForTests function in Document 3 with this:
// REPLACE the entire generatePdfForTests function with this:
const generatePdfForTests = async (testsToPrint) => {
  await loadThemeConfig();   
  console.log("generatePdfForTests called with:", testsToPrint);
  
  try {
    const patient = selectedUserForPrint || selectedUser;
    
    if (!patient) {
      console.error("No patient selected");
      toast.error("No patient selected!");
      return;
    }

    const doc = new jsPDF();
let fontOk = false;
let boldOk = false;

// --- REGULAR DejaVu ---
try {
  let fontBase64 = await loadFontAsBase64(`${process.env.PUBLIC_URL || ''}/DejaVuSans.ttf`);
  fontBase64 = String(fontBase64).replace(/^data:.*;base64,/, "");
  if (!fontBase64 || fontBase64.length < 5000) throw new Error("Regular font invalid");
  doc.addFileToVFS("DejaVuSans.ttf", fontBase64);
  doc.addFont("DejaVuSans.ttf", "DejaVu", "normal");
  doc.setFont("DejaVu", "normal");
  doc.getTextWidth("A");
  fontOk = true;
} catch (e) { console.error("DejaVu normal failed:", e.message); fontOk = false; }

// --- REAL BOLD DejaVu ---
try {
  let boldBase64 = await loadFontAsBase64(`${process.env.PUBLIC_URL || ''}/DejaVuSans-Bold.ttf`);
  boldBase64 = String(boldBase64).replace(/^data:.*;base64,/, "");
  if (!boldBase64 || boldBase64.length < 5000) throw new Error("Bold font missing/invalid");
  doc.addFileToVFS("DejaVuSans-Bold.ttf", boldBase64);
  doc.addFont("DejaVuSans-Bold.ttf", "DejaVu", "bold");
  doc.setFont("DejaVu", "bold");
  doc.getTextWidth("A");
  boldOk = true;
} catch (e) { console.error("DejaVu bold failed:", e.message); boldOk = false; }

doc.setFont(fontOk ? "DejaVu" : "helvetica", "normal");

console.log("🔤 LabReg FONT STATUS → fontOk:", fontOk, "boldOk:", boldOk); 

    const pageHeight = doc.internal.pageSize.getHeight();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageBuffer = 35;
    
    // ✅ NEW: Constants for signature area protection
    const SIGNATURE_AREA_HEIGHT = 50; // Space reserved for signatures at bottom
    const MIN_TEST_CONTENT_HEIGHT = 45; // Minimum height needed for a test block
    
    let hasRadiology = false;
    let currentPageNumber = 1;
    let lastPrintedDeptOnCurrentPage = null;
    let currentTestDeptName = null;
    // Helper to add new page
    // ✅ UPDATED: Helper to add new page - resets department tracking
const addNewPage = async () => {
  doc.addPage();
  currentPageNumber++;
  lastPrintedDeptOnCurrentPage = null; // ✅ Reset so department header prints on new page
  await addHeaderAndFooter(doc);
  return await printPatientDetails(doc, patient, 36);
};

// ✅ NEW: Helper function to print department header
const printDepartmentHeader = (deptName) => {
  doc.setFillColor(...THEME.headerBg);
  doc.setDrawColor(...THEME.border);
  doc.setLineWidth(0.2);
  const r = THEME.outline.deptHeader ? (+THEME.outline.radius || 0) : 0;
  const style = THEME.outline.deptHeader ? 'FD' : 'F';
  if (r > 0) doc.roundedRect(10, yPos - 5, 190, 8, r, r, style);
  else doc.rect(10, yPos - 5, 190, 8, style);
  doc.setFontSize(THEME.font.deptHeader).setFont('helvetica', 'bold').setTextColor(...THEME.headerTxt);
  doc.text(deptName.toUpperCase(), pageWidth / 2, yPos, { align: 'center' });
  doc.setTextColor(0, 0, 0);
  yPos += 5;
  lastPrintedDeptOnCurrentPage = deptName;
};

    // Start first page
    await addHeaderAndFooter(doc);
    let yPos = await printPatientDetails(doc, patient, 36);
    let lastPrintedDept = null;

    // Helper function to draw the main parameter table
    // ✅ UPDATED: Helper function to draw the main parameter table with department reprinting
const drawMainTable = async (rows, needsHead) => {
  if (!rows || rows.length <= 1) return; // Skip if only main test name row

  const tableHeightEstimate = rows.length * 8 + (needsHead ? 10 : 0);
  
  // Check against signature area
  if (yPos + tableHeightEstimate > pageHeight - SIGNATURE_AREA_HEIGHT) {
    yPos = await addNewPage();
    
    // ✅ On new page, reprint department header if needed
    if (currentTestDeptName && currentTestDeptName !== lastPrintedDeptOnCurrentPage) {
      printDepartmentHeader(currentTestDeptName);
    }
    
    needsHead = true; // Always need table header on new page
  }

      const C = THEME.columns;
const tableStartY = yPos;
const startPageNo = doc.internal.getNumberOfPages();

await autoTable(doc, {
  startY: yPos,
  head: needsHead ? [["TEST NAME", "RESULT", "UNITS", "NORMAL RANGES", "METHOD"]] : null,
  body: rows,
  theme: 'plain',
  headStyles: {
    fillColor: THEME.headerBg, textColor: THEME.headerTxt,
    fontStyle: 'bold', fontSize: THEME.font.tableHead
  },
  styles: { fontSize: THEME.font.tableBody, cellPadding: 2, valign: 'middle', textColor: [0,0,0] },
  columnStyles: {
    0: { cellWidth: C.testName.width, halign: C.testName.halign },
    1: { cellWidth: C.result.width,   halign: C.result.halign   },
    2: { cellWidth: C.unit.width,     halign: C.unit.halign     },
    3: { cellWidth: C.range.width,    halign: C.range.halign    },
    4: { cellWidth: C.method.width,   halign: C.method.halign   }
  },
  margin: { left: 10, right: 10 },
  didDrawCell: (data) => {
    // existing main-test underline
    if (data.section === 'body' && data.row.index === 0 && data.cell.raw?.isMainTest) {
      doc.setDrawColor(...THEME.border);
      doc.setLineWidth(0.2);
      const tw = doc.getTextWidth(data.cell.text[0]);
      const lineY = data.cell.y + data.cell.height - 1.5;
      doc.line(data.cell.x + 2, lineY, data.cell.x + 2 + tw, lineY);
    }
  
    // ✅ draw the arrow after the number, in DejaVu (helvetica can't render ↑)
    // ✅ underline + arrow for abnormal result
if (
  data.section === 'body' &&
  data.column.index === 1 &&              // RESULT column
  data.cell.raw?._flag                    // this cell has a flag
) {
  const flag = data.cell.raw._flag;
  const numberText = String(data.cell.text[0] || '');

  // measure the number in its own (helvetica bold) font
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(THEME.font.tableBody);
  const numW = doc.getTextWidth(numberText);

  const textX     = data.cell.x + data.cell.padding('left');
  const baselineY = data.cell.y + data.cell.height / 2 + 1;

  // ✅ NEW: underline just the number, same color as the flag
  doc.setDrawColor(...flag.color);
  doc.setLineWidth(0.2);
  doc.line(textX, baselineY + 1, textX + numW, baselineY + 1);

  // arrow after the number, drawn in DejaVu
  if (fontOk) doc.setFont('DejaVu', 'normal');
  doc.setTextColor(...flag.color);
  const arrowX = textX + numW + 1.5;
  doc.text(flag.label, arrowX, baselineY);

  // reset
  doc.setTextColor(0, 0, 0);
  doc.setFont('helvetica', 'normal');
}
  },
});

const endY = doc.lastAutoTable?.finalY ?? yPos;
if (doc.internal.getNumberOfPages() === startPageNo) {
  drawOutline(doc, THEME.outline.testTable, 10, tableStartY, 190, endY - tableStartY);
}
yPos = endY + 4;
    };

    // Build department map
    const departmentMap = {};
    (formData.departs || []).forEach(d => { departmentMap[d.cat_id] = d.cat_name; });

    // Loop through tests
    for (const test of testsToPrint) {
      console.log("Processing test:", test.lab_item_test_name || test.test_name);
      
      const params = Array.isArray(test.params) ? test.params : [];
      console.log("Test params count:", params.length);

      if (params.length === 0) {
        console.warn("Test has no params:", test);
        continue;
      }

      // ✅ NEW: Check if we have enough space for minimum test content before starting
      if (yPos + MIN_TEST_CONTENT_HEIGHT > pageHeight - SIGNATURE_AREA_HEIGHT) {
        yPos = await addNewPage();
      }

      // Determine department
      // Determine department
const deptName = (params[0] && params[0].test_cat && departmentMap[params[0].test_cat])
? departmentMap[params[0].test_cat]
: "OTHER REPORTS";

// ✅ Store current test's department for reprinting on new pages
currentTestDeptName = deptName;

if (deptName && deptName.toLowerCase() === "radiology") {
hasRadiology = true;
}

// ✅ UPDATED: Print department header only if different from last printed on THIS page
let addTableHead = false;
if (deptName && deptName !== lastPrintedDeptOnCurrentPage) {
// Check space for department header + test content
if (yPos + 15 + MIN_TEST_CONTENT_HEIGHT > pageHeight - SIGNATURE_AREA_HEIGHT) { 
  yPos = await addNewPage(); 
}
printDepartmentHeader(deptName);
addTableHead = true;
}

      // ✅ NEW: Before drawing test name row, check if we have space
    // ✅ UPDATED: Before drawing test name row, check if we have space
const spaceForTestBlock = 40; // test name + header + at least 2 param rows
if (yPos + spaceForTestBlock > pageHeight - SIGNATURE_AREA_HEIGHT) {
  yPos = await addNewPage();
  
  // ✅ On new page, reprint department header
  if (deptName && deptName !== lastPrintedDeptOnCurrentPage) {
    printDepartmentHeader(deptName);
  }
  
  addTableHead = true; // Need to add table header on new page
}

      // Main test name row
      let paramsRows = [];
      const mainTestNameRow = [{
        content: test.lab_item_test_name || test.test_name || 'Test',
        colSpan: 5,
        styles: { fontStyle: 'bold', textColor: [0, 0, 0], cellPadding: { top: 2, bottom: 2, left: 2 } },
        isMainTest: true
      }];
      paramsRows.push(mainTestNameRow);

      let hasResultInCurrentTable = false;

      // Process parameters
      for (const param of params) {
        const rawParamName = String(param.test_param_name || '');
        const isPdfStarred = /^\*.+\*$/.test(rawParamName.trim());
        const pdfParamName = isPdfStarred ? rawParamName.trim().replace(/^\*(.+)\*$/, '$1') : rawParamName;

        console.log("Processing param:", pdfParamName, "Type:", param.test_param_type);

        // Editor type params
        if (param.test_param_type === "Editor") {
          // Flush any pending table rows
          if (hasResultInCurrentTable) {
            await drawMainTable(paramsRows, addTableHead);
            paramsRows = [mainTestNameRow];
            hasResultInCurrentTable = false;
            addTableHead = true;
          }

          // ✅ UPDATED: Check against signature area
          // ✅ UPDATED: Check against signature area with department reprinting
if (yPos + 12 > pageHeight - SIGNATURE_AREA_HEIGHT) { 
  yPos = await addNewPage();
  // Reprint department header on new page
  if (currentTestDeptName && currentTestDeptName !== lastPrintedDeptOnCurrentPage) {
    printDepartmentHeader(currentTestDeptName);
  }
}
yPos += 4;
          doc.setFontSize(11);
          doc.setFont('helvetica', 'bold');
          doc.text(pdfParamName, 16, yPos);
          yPos += 7;

          const editorContent = String(param.result || '').trim();
          if (editorContent) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = editorContent;
            const tableElement = tempDiv.querySelector('table');

            const htmlContentToRender = (() => {
              if (!tableElement) return tempDiv.innerHTML;
              const cloned = tempDiv.cloneNode(true);
              const tbl = cloned.querySelector('table');
              if (tbl) tbl.remove();
              return cloned.innerHTML;
            })();

            if (htmlContentToRender && String(htmlContentToRender).trim()) {
              yPos = await drawHtmlContent(doc, htmlContentToRender, 16, yPos, {
                maxWidth: 178,
                addNewPage,
                pageHeight,
                pageBuffer: SIGNATURE_AREA_HEIGHT // ✅ Use signature area height
              });
              yPos += 4;
            }

            if (tableElement) {
              // ✅ UPDATED: Check against signature area with department reprinting
              if (yPos + 12 > pageHeight - SIGNATURE_AREA_HEIGHT) {
                yPos = await addNewPage();
                if (currentTestDeptName && currentTestDeptName !== lastPrintedDeptOnCurrentPage) {
                  printDepartmentHeader(currentTestDeptName);
                }
              }
              try {
                autoTable(doc, {
                  startY: yPos,
                  html: tableElement,
                  theme: 'grid',
                  styles: {
                    fontSize: 9,
                    cellPadding: 2,
                    valign: 'middle',
                    textColor: [0, 0, 0],
                    lineColor: [0, 0, 0],
                    lineWidth: 0.2
                  },
                  headStyles: {
                    textColor: [0, 0, 0],
                    fillColor: [255, 255, 255],
                    fontStyle: 'bold'
                  },
                  margin: { left: 14, right: 14 }
                });
                yPos = doc.lastAutoTable ? doc.lastAutoTable.finalY + 6 : yPos + 17;
              } catch (err) {
                console.warn("Table render failed, using fallback", err);
                const rows = [];
                tableElement.querySelectorAll('tr').forEach(tr => {
                  const cols = [];
                  tr.querySelectorAll('th, td').forEach(td => cols.push((td.innerText || '').trim()));
                  rows.push(cols);
                });
                if (rows.length) {
                  if (yPos + rows.length * 8 > pageHeight - SIGNATURE_AREA_HEIGHT) yPos = await addNewPage();
                  autoTable(doc, {
                    startY: yPos,
                    body: rows,
                    theme: 'grid',
                    styles: { fontSize: 9, cellPadding: 2, valign: 'middle' },
                    margin: { left: 14, right: 14 }
                  });
                  yPos = doc.lastAutoTable.finalY + 6;
                }
              }
            }
          }

          yPos += 6;
          continue;
        }

        // Non-Editor params
        const hasResult = param.result !== undefined && param.result !== null && String(param.result).trim() !== '';
        if (!hasResult && !isPdfStarred) {
          continue;
        }

       
        let resultWithFlag = hasResult ? String(param.result).trim() : '';
        let resultStyles = {
          halign: THEME.columns.result.halign,
          textColor: [0, 0, 0],
          ...(fontOk ? { font: 'DejaVu' } : {})
        };
        
        const rangeValue = formatCellValue(get_param_val(param));
        
        let _flagForCell = null;   // ✅ hold the arrow separately
        
        if (hasResult) {
          const flag = evaluateFlagSmart(resultWithFlag, rangeValue, patient);
          if (flag) {
            _flagForCell = flag;                    // ✅ store, do NOT append to text
            resultStyles = {
              ...resultStyles,
              textColor: flag.color,
              fontStyle: 'bold',
              font: 'helvetica'                     // ✅ real bold from jsPDF (no arrow in cell)
            };
          }
        
          if (param.is_bold === true) {
            resultStyles = {
              ...resultStyles,
              fontStyle: 'bold',
              textColor: THEME.flags.boldColor,
              font: 'helvetica'
            };
          }
        }
        
        paramsRows.push([
          { content: pdfParamName, styles: isPdfStarred ? { fontStyle: 'bold' } : {} },
          { content: resultWithFlag || '', styles: resultStyles, _flag: _flagForCell },  // ✅ arrow stored on cell
          param.test_range_type || '',
          genderRangeDisplay(rangeValue, patient) || '',
          param.test_param_method || ''
        ]);



hasResultInCurrentTable = true;
      }

      // Draw remaining table rows
      if (hasResultInCurrentTable) {
        await drawMainTable(paramsRows, addTableHead);
      }

      // Sample type (skip for radiology)
      const isRadiologyDept = (deptName && String(deptName).toLowerCase() === 'radiology') ||
        (params[0] && String(params[0].test_cat) === '60');

        if (!isRadiologyDept && params[0] && params[0].test_sample_type) {
          // ✅ UPDATED: Check against signature area with department reprinting
          if (yPos + 15 > pageHeight - SIGNATURE_AREA_HEIGHT) {
            yPos = await addNewPage();
            if (currentTestDeptName && currentTestDeptName !== lastPrintedDeptOnCurrentPage) {
              printDepartmentHeader(currentTestDeptName);
            }
          }
        autoTable(doc, {
          startY: yPos,
          body: [[{
            content: `Sample Type : ${params[0].test_sample_type}`,
            colSpan: 5,
            styles: { fontStyle: 'bold', textColor: [80, 80, 80] }
          }]],
          theme: 'plain',
          styles: { fontSize: 8, cellPadding: 1, valign: 'middle' },
          margin: { left: 14, right: 14 }
        });
        yPos = doc.lastAutoTable ? doc.lastAutoTable.finalY + 6 : yPos + 10;
      } else {
        yPos += 4;
      }

      // Interpretation / Impression / Notes - with signature area check
      // ✅ UPDATED: Interpretation / Impression / Notes - with department reprinting
if (test.interpretation) {
  if (yPos + 20 > pageHeight - SIGNATURE_AREA_HEIGHT) {
    yPos = await addNewPage();
    if (currentTestDeptName && currentTestDeptName !== lastPrintedDeptOnCurrentPage) {
      printDepartmentHeader(currentTestDeptName);
    }
  }
  yPos = await drawBorderedSection(doc, 'Interpretation', test.interpretation, yPos, addNewPage, pageHeight, SIGNATURE_AREA_HEIGHT);
}
if (test.impression) {
  if (yPos + 20 > pageHeight - SIGNATURE_AREA_HEIGHT) {
    yPos = await addNewPage();
    if (currentTestDeptName && currentTestDeptName !== lastPrintedDeptOnCurrentPage) {
      printDepartmentHeader(currentTestDeptName);
    }
  }
  yPos = await drawBorderedSection(doc, 'Impression', test.impression, yPos, addNewPage, pageHeight, SIGNATURE_AREA_HEIGHT);
}
if (test.notes) {
  if (yPos + 20 > pageHeight - SIGNATURE_AREA_HEIGHT) {
    yPos = await addNewPage();
    if (currentTestDeptName && currentTestDeptName !== lastPrintedDeptOnCurrentPage) {
      printDepartmentHeader(currentTestDeptName);
    }
  }
  yPos = await drawBorderedSection(doc, 'Notes:', test.notes, yPos, addNewPage, pageHeight, SIGNATURE_AREA_HEIGHT);
}
    }

    // End of report - check against signature area
    if (yPos + 20 > pageHeight - SIGNATURE_AREA_HEIGHT) yPos = await addNewPage();
    doc.setFontSize(12).setFont('helvetica', 'bold');
    doc.text('*** End of Report ***', pageWidth / 2, yPos + 12, { align: 'center' });

    // Add signatures and page numbers
    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      if (hasRadiology) {
        await addSignatures(doc, formData.selItem['60']);
      } else {
        await addSignatures(doc, formData.selItem['32']);
      }
      
      doc.setFontSize(8).setTextColor(0, 0, 0);
      const pageText = `Page ${i} of ${totalPages}`;
      doc.text(pageText, pageWidth - 14, pageHeight - 18, { align: 'right' });
    }

    // Open PDF
    const pdfBlob = doc.output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);
    const newWindow = window.open(pdfUrl, '_blank');
    if (newWindow) {
      newWindow.onload = () => { URL.revokeObjectURL(pdfUrl); };
    } else {
      const a = document.createElement('a');
      a.href = pdfUrl;
      a.download = `report_${patient.lab_reg_id || 'report'}.pdf`;
      a.click();
      URL.revokeObjectURL(pdfUrl);
    }
  } catch (err) {
    console.error("generatePdfForTests error:", err);
    Swal.fire({ icon: 'error', title: 'PDF Error', text: 'Failed to generate report PDF. See console for details.' });
  }
};


  // add header/footer/watermark helper used in generatePdfForTests
  const addHeaderAndFooter = async (doc) => {
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const watermarkBase64 = await imageUrlToBase64(watermarkImage);
    if (watermarkBase64) {
      try {
        // GState approach may not be present in all jsPDF builds; attempt safe add
        doc.setGState && doc.setGState(new doc.GState({ opacity: 0.08 }));
        doc.addImage(watermarkBase64, 'PNG', (pageWidth - 120) / 2, (pageHeight - 120) / 2, 120, 120);
        doc.setGState && doc.setGState(new doc.GState({ opacity: 1 }));
      } catch (e) {
        // fallback: ignore watermark if setGState not available
        console.warn("watermark add failed", e);
      }
    }

    const headerImageBase64 = await imageUrlToBase64(image);
    if (headerImageBase64) {
      try {
        doc.addImage(headerImageBase64, 0, 0, pageWidth, 30);
      } catch (e) {
        console.warn("header add failed", e);
      }
    }

    const footerImageBase64 = await imageUrlToBase64(footerImage);
    if (footerImageBase64) {
      try {
        doc.addImage(footerImageBase64, 0, pageHeight - 13, pageWidth, 13);
      } catch (e) {
        console.warn("footer add failed", e);
      }
    }
  };

  // format list filtering
  const filteredList = formData.search_key.trim() === ""
    ? formData.l1
    : (formData.l1 || []).filter(item =>
      (`${item.lab_reg_uhid}`.toLowerCase().includes(formData.search_key.toLowerCase()) ||
        `${item.lab_reg_id}`.toLowerCase().includes(formData.search_key.toLowerCase()) ||
        `${item.lab_reg_name}`.toLowerCase().includes(formData.search_key.toLowerCase()))
    );




    // single reliable effect to load edit record from sessionStorage.lab_dt
// ✅ EDIT RECORD LOADER - only runs if lab_dt exists in session
useEffect(() => {
  const storedLabDt = sessionStorage.getItem("lab_dt");
  
  // If no edit record, skip this effect (first useEffect handles normal list)
  if (!storedLabDt) {
    console.log("✅ No edit record - skipping edit loader");
    return;
  }

  console.log("📝 Loading edit record from session");

  const loadEditRecord = async () => {
    let parsed;
    try {
      parsed = JSON.parse(storedLabDt);
    } catch (e) {
      console.error("❌ Failed to parse sessionStorage.lab_dt:", e);
      // Fall back to normal list
      const todayStr = new Date().toISOString().split('T')[0];
      initData({ from: todayStr, to: todayStr });
      return;
    }

    // ... rest of your edit loading logic stays the same ...
    let items = parsed.params || parsed.tests || parsed.all_tests || [];

    if ((!items || items.length === 0) && parsed.lab_reg_id) {
      try {
        items = await fetchLabItemsByRegId(parsed.lab_reg_id);
      } catch (err) {
        console.error("fetchLabItemsByRegId failed:", err);
        items = [];
      }
    }

   const normalizedItems = (items || []).map(it => {
  const n = normalizeTest(it);
  if (!n.lab_item_test_name && n.name) n.lab_item_test_name = n.name;
  if (!n.lab_item_test_id) {
    n.lab_item_test_id = (it.lab_item_test_id || it.test_id || "");  // ✅ no lab_item_id / n.id
  }
  return n;
});

    const normalizedRecord = {
      ...parsed,
      tests: normalizedItems,
      params: normalizedItems,
      all_tests: normalizedItems,
      displayTestNames: normalizedItems.length 
        ? normalizedItems.map(t => (t.lab_item_test_name || t.name).trim()).join(' || ') 
        : (parsed.displayTestNames || '')
    };

    setFormData(prev => ({ ...prev, l1: [normalizedRecord] }));
    setSelectedUser(normalizedRecord);
    setEditItem(normalizedRecord);
    setCurrentTests(normalizedItems);
    setSelectedTests(normalizedItems.map(t => String(t.id)));

    console.log("✅ Edit record loaded successfully");
  };

  loadEditRecord();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []); // Run once on mount

  // groupedData logic same as your code, used by DataTable
  const groupedData = React.useMemo(() => {
    let data = filteredList || [];

    
   

    if (data.length === 0) return [];
  
    // If the list already contains grouped patient objects (with tests array)
    if (data[0].tests && Array.isArray(data[0].tests)) {
      return data.map(patient => {
        const { tests = [], ...rest } = patient;
        // ensure test names exist
        const safeTests = tests.map(t => {
          const n = normalizeTest(t);
          if (!n.lab_item_test_name && n.name) n.lab_item_test_name = n.name;
          return n;
        });
        return {
          ...rest,
          params: safeTests,
          displayTestNames: safeTests.map(s => (s.lab_item_test_name || s.name || '').trim()).join(' || ')
        };
      });
    } else {
      // original flattened items need grouping by lab_reg_id
      const grouped = Object.values(data.reduce((acc, testItem) => {
        const key = testItem.lab_reg_id;
        if (!acc[key]) {
          acc[key] = { ...testItem, all_tests: [] };
        }
        acc[key].all_tests.push(testItem);
        return acc;
      }, {}));
  
      return grouped.map(patient => {
        const safeAll = (patient.all_tests || []).map(t => {
          const n = normalizeTest(t);
          if (!n.lab_item_test_name && n.name) n.lab_item_test_name = n.name;
          return n;
        });
        return {
          ...patient,
          params: safeAll,
          displayTestNames: safeAll.map(s => (s.lab_item_test_name || s.name || '').trim()).join(' || ')
        };
      });
    }
  }, [filteredList, formData.departs, isDoctorLogin, loggedDoctorId, ldata]);
  
// Place this AFTER your groupedData useMemo
// Ensure computeDiscountAmount and fmtMoney are defined above this useEffect
useEffect(() => {
  const rows = groupedData || [];

  // Build a map keyed by lab_reg_id to avoid double-counting duplicates
  const byId = {};
  rows.forEach(r => {
    const id = String(r.lab_reg_id ?? r.lab_reg_id_parent ?? r.id ?? ('reg-' + JSON.stringify(r))).trim();
    // prefer the first occurrence (assume each lab_reg_id should be counted once)
    if (!byId[id]) {
      byId[id] = r;
    } else {
      // If you want to merge fields instead of ignoring duplicates, do it here.
      // For now we ignore duplicates to prevent double-counting totals.
    }
  });

  let totalAmount = 0;      // sum of lab_final_amt (final payable)
  let discountAmount = 0;   // sum of discounts
  let paidAmount = 0;       // sum of lab_paid
  let dueAmount = 0;        // sum of lab_due
  let totalCharges = 0;     // sum of lab_total (original charges)

  Object.values(byId).forEach(r => {
    const labTotalVal = Number(r.lab_total ?? 0);
    const labPaidVal = Number(r.lab_paid ?? 0);
    const labDueVal = Number(r.lab_due ?? 0);
    const labFinalVal = Number(r.lab_final_amt ?? r.lab_final ?? 0);

    // discount: use your computeDiscountAmount helper
    const discountVal = Number(computeDiscountAmount(r) || 0);

    totalCharges += labTotalVal;
    totalAmount += labFinalVal;
    discountAmount += discountVal;
    paidAmount += labPaidVal;
    // if lab_due is missing compute from final-paid as fallback
    const effectiveDue = Number(r.lab_due ?? (labFinalVal - labPaidVal) ?? 0);
    dueAmount += effectiveDue;
  });

  setTotals({
    totalAmount: Number(totalAmount.toFixed(2)),
    discountAmount: Number(discountAmount.toFixed(2)),
    paidAmount: Number(paidAmount.toFixed(2)),
    dueAmount: Number(dueAmount.toFixed(2)),
    totalCharges: Number(totalCharges.toFixed(2))
  });
}, [groupedData]);



  // --- DataTable columns config ---
 // --- Updated DataTable columns: larger Test Details, smaller Refered Doctor ---
const columns = [
   // Combined actions column: view / edit / delete (shows on hover)
   {
    name: '',
    cell: row => (
      <div className="row-actions" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        {/* View */}
        <button
          className="btn btn-outline-primary btn-sm"
          onClick={() => openViewModal(row)}
          title="View"
        >
          View
        </button>

        {/* Edit - with SweetAlert confirmation */}
        <button
          type="button"
          onClick={() => {
            try {
              // Admin bypass - but still confirm
              if (isAdmin) {
                Swal.fire({
                  title: 'Edit Registration?',
                  html: `
                    <div style="text-align: left; padding: 10px;">
                      <p><strong>Patient:</strong> ${row.lab_reg_name_title || ''} ${row.lab_reg_name || 'N/A'}</p>
                      <p><strong>UHID:</strong> ${row.lab_reg_uhid || 'N/A'}</p>
                      <p><strong>Reg ID:</strong> ${row.lab_reg_id || 'N/A'}</p>
                      <p style="margin-top: 10px; color: #666;">You are about to edit this registration.</p>
                    </div>
                  `,
                  icon: 'question',
                  showCancelButton: true,
                  confirmButtonColor: '#405189',
                  cancelButtonColor: '#6c757d',
                  confirmButtonText: 'Yes, Edit',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.isConfirmed) {
                    sessionStorage.setItem("lab_dt", JSON.stringify(row));
                    window.location.href = "/registrations";
                  }
                });
                return;
              }

              // Non-admin: check 24-hour restriction
              const editable = canEditWithin24Hrs(row);
              
              if (!editable) {
                Swal.fire({
                  icon: "warning",
                  title: "Cannot Edit",
                  text: "This registration is older than 20 days and cannot be edited.",
                  confirmButtonText: "OK",
                  confirmButtonColor: '#405189'
                });
                return;
              }

              // Within 24 hours - show confirmation
              Swal.fire({
                title: 'Edit Registration?',
                html: `
                  <div style="text-align: left; padding: 10px;">
                    <p><strong>Patient:</strong> ${row.lab_reg_name_title || ''} ${row.lab_reg_name || 'N/A'}</p>
                    <p><strong>UHID:</strong> ${row.lab_reg_uhid || 'N/A'}</p>
                    <p><strong>Reg ID:</strong> ${row.lab_reg_id || 'N/A'}</p>
                    <p style="margin-top: 10px; color: #666;">You are about to edit this registration.</p>
                  </div>
                `,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#405189',
                cancelButtonColor: '#6c757d',
                confirmButtonText: 'Yes, Edit',
                cancelButtonText: 'Cancel'
              }).then((result) => {
                if (result.isConfirmed) {
                  sessionStorage.setItem("lab_dt", JSON.stringify(row));
                  window.location.href = "/registrations";
                }
              });

            } catch (e) {
              console.error("Edit click error:", e);
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to initiate edit. Please try again.',
                confirmButtonColor: '#405189'
              });
            }
          }}
         className="btn btn-sm btn-outline-warning"
         title={isAdmin ? "Edit (Admin)" : "Edit (within 20 days only)"}
        >
          <i className="ri-pencil-fill fs-16"></i>
        </button>

        {/* Delete - only for admins with detailed confirmation */}
        <button
          type="button"
          disabled={!isAdmin}
          onClick={() => {
            if (!isAdmin) {
              Swal.fire({
                icon: "info",
                title: "Permission Required",
                text: "Only administrators can delete registrations.",
                confirmButtonText: "OK",
                confirmButtonColor: '#405189'
              });
              return;
            }

            // Admin confirmation with detailed info
            Swal.fire({
              title: 'Are you sure?',
              html: `
                <div style="text-align: left; padding: 10px;">
                  <p style="color: #d33; margin-bottom: 15px;"><strong>⚠️ This action cannot be undone!</strong></p>
                  <hr style="margin: 10px 0;">
                  <p><strong>Patient:</strong> ${row.lab_reg_name_title || ''} ${row.lab_reg_name || 'N/A'}</p>
                  <p><strong>UHID:</strong> ${row.lab_reg_uhid || 'N/A'}</p>
                  <p><strong>Reg ID:</strong> ${row.lab_reg_id || 'N/A'}</p>
                  <p><strong>Tests:</strong> ${row.displayTestNames || 'N/A'}</p>
                  <p><strong>Total Amount:</strong> ₹${Number(row.lab_final_amt || 0).toFixed(2)}</p>
                  <hr style="margin: 10px 0;">
                  <p style="margin-top: 10px; color: #666;">All associated data will be permanently deleted.</p>
                </div>
              `,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#d33',
              cancelButtonColor: '#6c757d',
              confirmButtonText: 'Yes, Delete',
              cancelButtonText: 'Cancel',
              reverseButtons: true
            }).then((result) => {
              if (result.isConfirmed) {
                // Show loading state
                Swal.fire({
                  title: 'Deleting...',
                  text: 'Please wait',
                  allowOutsideClick: false,
                  didOpen: () => {
                    Swal.showLoading();
                  }
                });

                // Perform delete
                delItem(row).then(() => {
                  Swal.fire({
                    icon: 'success',
                    title: 'Deleted!',
                    text: 'Registration has been deleted successfully.',
                    timer: 2000,
                    showConfirmButton: false
                  });
                }).catch((error) => {
                  console.error("Delete error:", error);
                  Swal.fire({
                    icon: 'error',
                    title: 'Delete Failed',
                    text: 'Could not delete the registration. Please try again.',
                    confirmButtonColor: '#405189'
                  });
                });
              }
            });
          }}
          className="btn btn-sm btn-outline-danger"
          style={{ opacity: !isAdmin ? 0.6 : 1 }}
          title={isAdmin ? "Delete" : "Admin only"}
        >
          <i className="ri-delete-bin-5-fill fs-16"></i>
        </button>


        
      </div>
    ),
    width: '220px',
    ignoreRowClick: true,
    allowOverflow: true,
  },


  // keep your three-dot print column (optional) - I left it as-is with small changes
  {
    name: '',
    cell: (row) => (
      <div style={{ position: 'relative' }}>
        <button
          className="btn btn-link text-muted p-0"
          onClick={() => {
            setSelectedUserForPrint(row);
            setShowModal(true);
          }}
          title="More"
        >
          <i className="ri-more-2-fill fs-18"></i>
        </button>
      </div>
    ),
    width: '10px',
    ignoreRowClick: true,
    allowOverflow: true,
  },

  {
    name: 'Payment Action',
    selector: row => Number(row.lab_due || 0).toFixed(2),
    cell: row => {
      const due = parseFloat(row.lab_due || 0);
      const paid = parseFloat(row.lab_paid || 0);
      const refunded = parseFloat(labRefundMap[row.lab_reg_id] || 0);
      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4 }}>
          <div style={{ fontWeight: 600 }}>
            Due: ₹{due.toFixed(2)}
          </div>
          
          <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
            {/* Pay Button - Only if due > 0 */}
            {due > 0 && (
              <button 
                onClick={() => makePayment(row)} 
                className="btn btn-success btn-sm"
                title="Add Payment"
                style={{ fontSize: '11px', padding: '2px 8px' }}>
                <i className="ri-money-rupee-circle-line me-1"></i>
                Pay
              </button>
            )}
            
            {/* Refund Button - Only if paid > 0 */}
            {paid > 0 && (
              <button 
                onClick={() => makeRefund(row)} 
                className="btn btn-danger btn-sm"
                title="Refund Payment"
                style={{ fontSize: '11px', padding: '2px 8px' }}>
                <i className="ri-refund-2-line me-1"></i>
                Refund
              </button>
            )}

{refunded > 0 && (
          <div style={{ fontSize: '11px', color: '#dc3545', marginTop: 2 }}>
            <i className="ri-refund-2-line" style={{ fontSize: 10 }}></i>
            {' '}Refunded: ₹{refunded.toFixed(2)}
          </div>
        )}
          </div>
        </div>
      );
    },
    right: true,
    width: '180px'
  },
   
  {
    name: 'SR',
    selector: (row, i) => groupedData.indexOf(row) + 1,
    width: '80px'
  },
  { name: 'UHID No', selector: row => row.lab_reg_uhid || '-', sortable: true, wrap: true, width: '120px' },
 

  // Patient Details (kept moderate)
  {
    name: 'Patient Details',
    selector: row => `${row.lab_reg_name_title || ''} ${row.lab_reg_name || ''}`,
    cell: row => (
      <div>
        <div>{row.lab_reg_name_title} {row.lab_reg_name}</div>
        <small>
          <strong>Age:</strong> {row.lab_reg_age_year}y {row.lab_reg_age_month}m {row.lab_reg_age_day}d<br />
          <strong>Gender:</strong> {row.lab_reg_gender}<br />
          <strong>Mobile:</strong> {row.lab_reg_mobile}
        </small>
      </div>
    ),
    sortable: true,
    grow: 0,
    wrap: true,
    width: '180px'
  },
  { name: 'Reg No', selector: row => row.lab_reg_id || '-', sortable: true, wrap: true, width: '100px' },

  {
    name: 'Status',
    selector: row => row.lab_reg_status,
    cell: row => {
      const status = (row.lab_reg_status || '').toString().trim().toLowerCase();
      const canReport = canAccessReportEntry();
  
      return (
        <div style={{ textAlign: 'center' }}>
          {/* Pending */}
          {status === "pending" && (
            <div>
              <i className="ri-flask-fill" style={{ color: "red", fontSize: "24px" }}></i>
            </div>
          )}
  
          {/* Sample Collected → Show Report Entry button */}
          {status === "sample collected" && (
            <div>
              <i className="bi bi-droplet-half" style={{ color: "red", fontSize: "20px" }}></i>
              <div style={{ marginTop: 4 }}>
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={() => handleReportEntry(row)}
                  title={canReport ? "Go to Report Entry" : "Only Admin/Pathologist can access"}
                  style={{ fontSize: '11px', padding: '2px 8px' }}
                >
                  <i className="ri-file-edit-line me-1"></i>
                  Report Entry
                </button>
              </div>
            </div>
          )}
  
          {/* Completed + No Due → Green print + Edit Report button */}
          {status === "completed" && Number(row.lab_due || 0) === 0 && (
            <div>
              <div className="d-flex justify-content-center align-items-center gap-2">
                <i
                  className="ri-printer-fill fs-20"
                  style={{ color: "green", cursor: "pointer" }}
                  title="Print Report"
                  onClick={() => {
                    console.log("🖨️ Print icon clicked for patient:", row.lab_reg_id);
                    openReportModal([], row);
                  }}
                />
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm"
                  onClick={() => handleReportEntry(row)}
                  title={canReport ? "Edit Report" : "Only Admin/Pathologist can access"}
                  style={{ fontSize: '11px', padding: '2px 6px' }}
                >
                  <i className="ri-edit-line"></i>
                </button>
              </div>
            </div>
          )}
  
          {/* Completed + Due > 0 → Blue print with due warning */}
          {status === "completed" && Number(row.lab_due || 0) > 0 && (
            <div>
              <div className="d-flex justify-content-center align-items-center gap-2">
                <i
                  className="ri-printer-fill fs-20"
                  style={{ color: "blue", cursor: "pointer" }}
                  title={`Due: ₹${Number(row.lab_due).toFixed(2)}`}
                  onClick={() => {
                    Swal.fire({
                      icon: "warning",
                      title: "Payment Due",
                      text: `This patient has ₹${Number(row.lab_due).toFixed(2)} due.`,
                      confirmButtonText: "OK"
                    });
                  }}
                />
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm"
                  onClick={() => handleReportEntry(row)}
                  title={canReport ? "Edit Report" : "Only Admin/Pathologist can access"}
                  style={{ fontSize: '11px', padding: '2px 6px' }}
                >
                  <i className="ri-edit-line"></i>
                </button>
              </div>
            </div>
          )}
        </div>
      );
    },
    center: true,
    width: '190px'
  },
  
  // Shrink Refered Doctor column
  { name: 'Refered Doctor', selector: row => row.lab_reg_referral || '-', sortable: true, wrap: true, width: '140px' },

  // Make Test Details take more space (larger grow)
  { name: 'Test Details', selector: row => row.displayTestNames || 'N/A', wrap: true, grow: 0,width: '230px' },

  


  {
    name: 'Patient Type',
    selector: row => row.lab_reg_type,
    center: true,
    width: '130px',
    cell: row => {
      const raw = (row.lab_reg_type || '').toString().trim().toLowerCase();
      let badgeClass = 'badge bg-secondary';
      let label = row.lab_reg_type || 'N/A';
  
      // map common types to badge colors
      switch (raw) {
        case 'opd':
        case 'outpatient':
          badgeClass = 'badge bg-info text-dark';
          label = 'OPD';
          break;
        case 'ipd':
        case 'inpatient':
          badgeClass = 'badge bg-primary';
          label = 'IPD';
          break;
        case 'emergency':
        case 'er':
        case 'casualty':
          badgeClass = 'badge bg-danger';
          label = 'Emergency';
          break;
        case 'corporate':
          badgeClass = 'badge bg-success';
          label = 'Corporate';
          break;
        case 'referral':
          badgeClass = 'badge bg-warning text-dark';
          label = 'Referral';
          break;
        default:
          // keep original text but title-case it for display
          label = (row.lab_reg_type || 'Other').toString().replace(/\w\S*/g, w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
          badgeClass = 'badge bg-secondary';
      }
  
      return (
        <div style={{ textAlign: 'center' }}>
          <span className={badgeClass} style={{ padding: '6px 10px', fontSize: '0.95rem' }}>
            {label}
          </span>
        </div>
      );
    }
  },
  
  { name: 'Total Amount', selector: row => Number(row.lab_total  || 0).toFixed(2), right: true, width: '120px' },
  
  { 
    name: 'Discount', 
    selector: row => fmtMoney(computeDiscount(row)), 
    right: true, 
    width: '120px',
    cell: row => (
      <div>
        {fmtMoney(computeDiscount(row))}
      </div>
    )
  },

  { name: 'Final Amount', selector: row => fmtMoney(row.lab_final_amt || 0), right: true, width: '120px' },
  { 
    name: 'Paid Amount', 
    selector: row => Number(row.lab_paid || 0).toFixed(2), 
    right: true, 
    width: '140px',
    cell: row => {
      const paid = parseFloat(row.lab_paid || 0);
      const refunded = parseFloat(labRefundMap[row.lab_reg_id] || 0);
      
      return (
        <div style={{ textAlign: 'right', width: '100%' }}>
          <div className="text-success fw-semibold">
            ₹{paid.toFixed(2)}
          </div>
          {refunded > 0 && (
            <div style={{ fontSize: '11px', color: '#dc3545', marginTop: 2 }}>
              <i className="ri-refund-2-line" style={{ fontSize: 10 }}></i>
              {' '}Refunded: ₹{refunded.toFixed(2)}
            </div>
          )}
        </div>
      );
    }
  },

  

  { name: 'Registration Datetime', selector: row => formatDateTime(row.lab_reg_datetime) || '-', wrap: true, width: '200px' },
  {
    name: 'Last Used',
    selector: row => row.last_used || '',
    sortable: true,
    width: '160px'
  },
  
  
   
];


 

  const handleDownloadClick = () => {
    // If you want a single-click download for selected tests, reuse handlePrintClick but save blob
    handlePrintClick();
  };

  // component UI
  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card" id="orderList">
              <div className="card-header border-0">
                <div className="row align-items-center gy-3">
                  <div className="col-sm">
                    <h2 className="card-title mb-0" style={{ color: "#405189" }}>Lab Patient Details</h2>
                  </div>
                  <div className="col-sm-auto">
                    <div className="d-flex gap-1 flex-wrap">
                    <a href="#!" onClick={(e) => {
  e.preventDefault();
  sessionStorage.removeItem("lab_dt");
  navigate("/registrations"); // Fast navigation without reload
}}>
  <button type="button" className="btn btn-success add-btn">
    <i className="ri-add-line align-bottom me-1"></i> Add Patient
  </button>
</a>
                      <button className="btn btn-soft-danger" id="remove-actions">
                        <i className="ri-delete-bin-2-line"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-body border border-dashed border-end-0 border-start-0">
                <form>
                  <div className="row g-3">
                    <div className="col-md-2">
                      <label className="form-label">From</label>
                      <input className="form-control" type="date" name="from" onChange={handleChange} value={formData.from} />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">To</label>
                      <input className="form-control" type="date" name="to" onChange={handleChange} value={formData.to} />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label"></label>
                      <div className="search-box" style={{ display: "flex" }}>
                        {/* <button type="button" onClick={initData} className="btn btn-success">Search</button> */}
                        
                        <button type="button" onClick={() => {
  console.log("🔄 Clear button clicked");
  
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const dd = String(today.getDate()).padStart(2, '0');
  const todayStr = `${yyyy}-${mm}-${dd}`;

  console.log("📅 Resetting to today:", todayStr);

  // Update UI immediately
  setFormData(prev => ({ 
    ...prev, 
    search_key: "", 
    from: todayStr, 
    to: todayStr, 
    page_no: 0 
  }));

  // Fetch with explicit dates (no race condition)
  setTimeout(() => {
    console.log("🔄 Calling initData after clear");
    initData({ from: todayStr, to: todayStr, search_key: "" });
  }, 50);
  
}} className="btn btn-info">Clear</button>

                      </div>
                    </div>
                    <div className="col-md-3"></div>
                    <div className="col-md-3" style={{ textAlign: "right" }}>
                      <label className="form-label"></label>
                      <div className="search-box">
                        <input className="form-control search" placeholder="Search..." type="text"
                          name="search_key" onChange={handleChange} value={formData.search_key} />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <br />

              <div className="card-body pt-0">
                <div className="table-responsive table-card mb-1">

                  {/* React DataTable */}
                  <DataTable
                    columns={columns}
                    data={groupedData || []}
                    pagination={true}
  // set the rows per page to the total number of rows so everything appears
  paginationPerPage={(groupedData || []).length || 10}
  paginationRowsPerPageOptions={[10, 25, 50, (groupedData || []).length || 100]}
                    highlightOnHover
                    pointerOnHover
                    responsive
                    dense={false}
                    noHeader
                  
                    striped
                    conditionalRowStyles={[
                      {
                        when: row => row.lab_reg_status === "Sample Collected",
                        style: { backgroundColor: '#e3f9e5' }
                      }
                    ]}
                    customStyles={{
                      rows: {
                        style: {
                          minHeight: '58px',     // more row height
                          fontSize: '16px'       // larger text in rows
                        }
                      },
                      headCells: {
                        style: {
                          backgroundColor: '#f1f5fb',
                          color: '#405189',
                          fontSize: '15px',      // larger header text
                          fontWeight: '700',
                          paddingLeft: '14px',
                          paddingRight: '14px',
                        }
                      },
                      cells: {
                        style: {
                          paddingLeft: '14px',
                          paddingRight: '14px',
                          fontSize: '15px',      // larger body text
                          lineHeight: '20px'
                        }
                      }
                    }}
                  />



                </div>

                <div className="d-flex justify-content-between align-items-center">
                <div className="pagination-wrap hstack gap-2">
                <div className="row text-center">
  
                &nbsp;&nbsp;
  
    <div className="alert alert-primary col-lg col-md-4 col-sm-6 col-12" > 
    <strong
    style={{ cursor: 'pointer'}}
    onClick={() => openFooterModal('total')}
    title="Show patients with a total amount"
  >
      
      Total Amount: {typeof fmtMoney === 'function' ? fmtMoney(totals.totalCharges) : Number(totals.totalCharges || 0).toFixed(2)}
      </strong>
    </div>
  
  
 
&nbsp;&nbsp;
  
   <div className="alert alert-info col-lg col-md-4 col-sm-6 col-12" > 
    
   <strong
    style={{ cursor: 'pointer' }}
    onClick={() => openFooterModal('final')}
    title="Show patients by final payable amount"
  >
     Final Amount: {typeof fmtMoney === 'function' ? fmtMoney(totals.totalAmount) : Number(totals.totalAmount || 0).toFixed(2)}
  </strong>
  </div>
  

  &nbsp;&nbsp;
   <div className="alert alert-warning col-lg col-md-4 col-sm-6 col-12" > 
   <strong
    style={{ cursor: 'pointer'}}
    onClick={() => openFooterModal('discount')}
    title="Show patients with discount"
  >
     Discount Amount: {typeof fmtMoney === 'function' ? fmtMoney(totals.discountAmount) : Number(totals.discountAmount || 0).toFixed(2)}
  </strong>
  </div>
  

  &nbsp;&nbsp;
   <div className="alert alert-success col-lg col-md-4 col-sm-6 col-12" > 
   <strong
    style={{ cursor: 'pointer' }}
    onClick={() => openFooterModal('paid')}
    title="Show patients with paid amount"
  >
     Paid Amount: {typeof fmtMoney === 'function' ? fmtMoney(totals.paidAmount) : Number(totals.paidAmount || 0).toFixed(2)}
  </strong>

  </div>

  &nbsp;&nbsp;
  
  <div className="alert alert-danger col-lg col-md-4 col-sm-6 col-12" > 
  <strong
    style={{ cursor: 'pointer'}}
    onClick={() => openFooterModal('due')}
    title="Show patients with due amount"
  >
    Due Amount: {typeof fmtMoney === 'function' ? fmtMoney(totals.dueAmount) : Number(totals.dueAmount || 0).toFixed(2)}
  </strong>
  </div>



</div>

</div>


                  {/* <div className="pagination-wrap hstack gap-2">
                    <a className="page-item pagination-prev" href="#!" onClick={(e) => {
                      e.preventDefault();
                      if (formData.page_no > 0) {
                        setFormData(prev => ({ ...prev, page_no: prev.page_no - 1 }));
                        initData();
                      }
                    }}>Previous</a>
                    <ul className="pagination listjs-pagination mb-0"></ul>
                    <a className="page-item pagination-next" href="#!" onClick={(e) => {
                      e.preventDefault();
                      setFormData(prev => ({ ...prev, page_no: prev.page_no + 1 }));
                      initData();
                    }}>Next</a>
                  </div> */}
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      <AddPayModel item={payItem} onUpNow={onUpNow} onHide={() => setPayItem(null)} />
      <button id="addbt453" style={{ display: "none" }} type="button"
        className="btn btn-success add-btn" data-bs-toggle="modal" data-bs-target="#showModal"></button>

      <SampleModel
        item={selItem}
        onUpNow={onUpNow1}
        show={!!selItem}
        onHide={() => {
          setSelItem(null);
        }}
        onCollected={(id) => {
          setFormData(prev => {
            const newL1 = (prev.l1 || []).map(x => {
              if (String(x.lab_reg_id) === String(id)) {
                return { ...x, lab_reg_status: 'Sample Collected' };
              }
              return x;
            });
            return { ...prev, l1: newL1 };
          });
          setSelItem(null);
        }}
      />



<Modal show={showFooterModal} onHide={() => setShowFooterModal(false)} size="xl" centered>
  <Modal.Header closeButton>
    <Modal.Title>{footerModalTitle}</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    {Array.isArray(footerModalRows) && footerModalRows.length ? (
      <div style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        <table className="table table-sm table-hover">
          <thead>
            <tr>
              <th style={{ width: 40 }}>#</th>
              <th>UHID</th>
              <th>Patient</th>
              <th style={{ minWidth: 260 }}>Tests</th>
              <th style={{ textAlign: 'right', width: 110 }}>Total</th>
              <th style={{ textAlign: 'right', width: 110 }}>Discount</th>
              <th style={{ textAlign: 'right', width: 110 }}>Final</th>
              <th style={{ textAlign: 'right', width: 110 }}>Paid</th>
              <th style={{ textAlign: 'right', width: 110 }}>Due</th>
              <th style={{ width: 220 }}>Action</th>
            </tr>
          </thead>

          <tbody>
            {footerModalRows.map((r, i) => (
              <tr key={r.lab_reg_id ?? i}>
                <td>{i + 1}</td>
                <td>{r.lab_reg_uhid || '-'}</td>
                <td>{`${(r.lab_reg_name_title || '').trim()} ${(r.lab_reg_name || '').trim()}`.trim() || '-'}</td>

                <td style={{
                  maxWidth: 520,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}>
                  {r.displayTestNames || (Array.isArray(r.params) ? r.params.map(t => t.lab_item_test_name || t.name).join(' || ') : '-')}
                </td>

                <td style={{ textAlign: 'right' }}>
                  {typeof fmtMoney === 'function' ? fmtMoney(r.lab_total) : Number(r.lab_total || 0).toFixed(2)}
                </td>

                <td style={{ textAlign: 'right' }}>
                  <span title={typeof discountSourceLabel === 'function' ? discountSourceLabel(r) : ''}>
                    {typeof fmtMoney === 'function' ? fmtMoney(computeDiscountAmount(r)) : Number(computeDiscountAmount(r) || 0).toFixed(2)}
                  </span>
                </td>

                <td style={{ textAlign: 'right' }}>
                  {typeof fmtMoney === 'function' ? fmtMoney(r.lab_final_amt) : Number(r.lab_final_amt || 0).toFixed(2)}
                </td>

                <td style={{ textAlign: 'right' }}>
                  {typeof fmtMoney === 'function' ? fmtMoney(r.lab_paid) : Number(r.lab_paid || 0).toFixed(2)}
                </td>

                <td style={{ textAlign: 'right' }}>
                  {typeof fmtMoney === 'function' ? fmtMoney(r.lab_due) : Number(r.lab_due || 0).toFixed(2)}
                </td>

                <td>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    <button
                      className="btn btn-sm btn-primary"
                      onClick={() => { openViewModal(r); setShowFooterModal(false); }}
                    >
                      View
                    </button>

                    <button
                      className="btn btn-sm btn-warning"
                      onClick={() => {
                        sessionStorage.setItem("lab_dt", JSON.stringify(r));
                        window.location.href = "/registrations";
                      }}
                    >
                      Edit
                    </button>

                    {/* Uncomment / enable if you want delete here (admins only) */}
                    {/*
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => {
                        if (!isAdmin) {
                          Swal.fire({ icon: "info", title: "Permission required", text: "Only admins can delete." });
                          return;
                        }
                        Swal.fire({
                          title: 'Are you sure?',
                          text: `Delete registration ${r.lab_reg_id || ''} ?`,
                          icon: 'warning',
                          showCancelButton: true,
                          confirmButtonText: 'Yes, delete'
                        }).then(result => {
                          if (result.isConfirmed) {
                            delItem(r);
                            // update local modal rows to reflect deletion immediately
                            setFooterModalRows(prev => prev.filter(x => String(x.lab_reg_id) !== String(r.lab_reg_id)));
                          }
                        });
                      }}
                    >
                      Delete
                    </button>
                    */}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : (
      <div>No records match this filter.</div>
    )}
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowFooterModal(false)}>Close</Button>
  </Modal.Footer>
</Modal>




{/* View modal */}
<Modal show={showViewModal} onHide={() => setShowViewModal(false)} size="lg">
  <Modal.Header closeButton>
    <Modal.Title>Patient Details</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {viewItem ? (
      <div>
        <div className="row">
          <div className="col-md-6">
            <p><strong>UHID:</strong> {viewItem.lab_reg_uhid || 'N/A'}</p>
            <p><strong>Patient:</strong> {`${viewItem.lab_reg_name_title || ''} ${viewItem.lab_reg_name || ''}`}</p>
            <p><strong>Ref Doctor:</strong> {viewItem.lab_reg_referral || 'N/A'}</p>
            <p><strong>Created by:</strong> {viewItem.last_used || (viewItem.fname || '')}</p>
          </div>
          <div className="col-md-6">
            <p><strong>Lab Total (Charges):</strong> {Number(viewItem.lab_total ?? 0).toFixed(2)}</p>
            <p><strong>Discount:</strong> {Number(computeDiscountAmount(viewItem)).toFixed(2)}</p>
            <p><strong>Final Amount:</strong> {Number(viewItem.lab_final_amt ?? 0).toFixed(2)}</p>
            <p><strong>Paid:</strong> {Number(viewItem.lab_paid ?? 0).toFixed(2)}</p>
            <p><strong>Due:</strong> {Number(viewItem.lab_due ?? 0).toFixed(2)}</p>
          </div>
        </div>

        <hr />

        <div>
          <p><strong>Test Details:</strong></p>
          <div style={{ maxHeight: 180, overflowY: 'auto', padding: 8, background: '#f8f9fb' }}>
            {Array.isArray(viewItem.params) && viewItem.params.length > 0 ? (
              <ul style={{ margin: 0, paddingLeft: 18 }}>
                {viewItem.params.map((t, i) => (
                  <li key={i}>{t.lab_item_test_name || t.test_name || t.name || '-'}</li>
                ))}
              </ul>
            ) : (viewItem.displayTestNames ? <div>{viewItem.displayTestNames}</div> : <div>-</div>)}
          </div>
        </div>

        <hr />

        <div className="row">
          <div className="col-md-6">
            <p><strong>Later Paid Amount:</strong> {Number(viewItem.lab_due_pay_amount ?? 0).toFixed(2)}</p>
            <p><strong>Later Paid Date:</strong> {viewItem.lab_due_pay_date || '-'}</p>
          </div>
          <div className="col-md-6">
            <p><strong>Later Paid By (ID):</strong> {viewItem.lab_due_pay_user || '-'}</p>
            <p><strong>Later Paid By (Name):</strong> {viewItem.lab_due_pay_user_name || viewItem.lab_due_pay_user||  '-'}</p>
          </div>
        </div>
      </div>
    ) : (
      <div>No data</div>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowViewModal(false)}>Close</Button>
  </Modal.Footer>
</Modal>

      {/* Print modal (triggered by 3-dot action) */}
      {showModal && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog" style={{ marginTop: "8rem" }}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Print Options</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>

              <div className="modal-body">
                <label className="form-label d-block mb-2">Select Header Option</label>

                <div className="form-check">
                  <input className="form-check-input" type="radio" name="headerOption" id="withHeader" value="with" defaultChecked />
                  <label className="form-check-label" htmlFor="withHeader">With Header</label>
                </div>

                <div className="form-check">
                  <input className="form-check-input" type="radio" name="headerOption" id="withoutHeader" value="without" />
                  <label className="form-check-label" htmlFor="withoutHeader">Without Header</label>
                </div>
              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
                <button type="button" className="btn btn-primary" onClick={() => {
                  if (selectedUserForPrint) {
                    const headerOption = document.querySelector('input[name="headerOption"]:checked').value;
                    generatePDF(headerOption, selectedUserForPrint);
                    setShowModal(false);
                  }
                }}>Proceed to Print</button>
              </div>

            </div>
          </div>
        </div>
      )}

      {/* Report modal (select tests + header type) */}
     {/* Report Modal - Test Selection */}
{/* Report Modal - Test Selection */}
{/* Report Modal - Test Selection */}
{/* Report Modal - Test Selection */}
<Modal show={showReportModal} onHide={() => setShowReportModal(false)} size="lg">
  <Modal.Header closeButton>
    <Modal.Title>Select Tests to Print</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {/* Select All Checkbox */}
    <div className="mb-3 d-flex align-items-center" style={{ gap: 8 }}>
      <input
        type="checkbox"
        id="select-all-tests-modal"
        checked={selectAllTests}
        onChange={handleToggleSelectAll}
      />
      <label htmlFor="select-all-tests-modal" style={{ margin: 0, fontWeight: 600 }}>
        Select All ({currentTests?.length || 0} tests)
      </label>
    </div>

    <hr />

    {/* Test List with Checkboxes and Approval Status */}
    <div style={{ maxHeight: 400, overflowY: 'auto', paddingRight: 8 }}>
      {(currentTests || []).map((test, idx) => {
        const id = String(test.id || test.lab_item_test_id || `test-${idx}`);
        const label = test.lab_item_test_name || test.name || `Test ${idx + 1}`;
        const paramCount = test.params?.length || 0;
        const hasResults = test.params?.some(p => p.result && String(p.result).trim() !== '') || false;
        
        // Check approval status
        const isApproved = test.report_info?.is_approved === "1" || 
                          test.is_approved === "1" || 
                          test.is_approved === 1;

        // ✅ Check if this test has duplicates (same lab_item_test_id)
        const labItemTestId = String(test.lab_item_test_id || test.test_id || '');
        const duplicateCount = (currentTests || []).filter(t => {
          const tLabItemTestId = String(t.lab_item_test_id || t.test_id || '');
          return tLabItemTestId === labItemTestId && tLabItemTestId !== '';
        }).length;
        const hasDuplicates = duplicateCount > 1;

        return (
          <div key={id} className="mb-2 d-flex align-items-start p-2" style={{ 
            border: '1px solid #e0e0e0', 
            borderRadius: 4,
            backgroundColor: !isApproved ? '#fff8e1' : (selectedTests.includes(id) ? '#f0f8ff' : '#fff'),
            opacity: !isApproved ? 0.7 : 1,
            // ✅ Highlight duplicates with a different border
            borderLeft: hasDuplicates ? '4px solid #17a2b8' : '1px solid #e0e0e0'
          }}>
            <input
              type="checkbox"
              id={`report-test-${id}`}
              checked={selectedTests.includes(id)}
              onChange={() => handleCheckboxChange({ ...test, id })}
              disabled={!isApproved}
              style={{ marginRight: 8, marginTop: 4 }}
            />
            <label 
              htmlFor={`report-test-${id}`} 
              style={{ margin: 0, cursor: isApproved ? 'pointer' : 'not-allowed', userSelect: 'none', flex: 1 }}
            >
              <div style={{ fontWeight: 500, display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                {label}
                {/* Approval Badge */}
                {isApproved ? (
                  <span className="badge bg-success">Approved</span>
                ) : (
                  <span className="badge bg-warning text-dark">Not Approved</span>
                )}
                {/* ✅ Duplicate Badge */}
                {hasDuplicates && (
                  <span className="badge bg-info" title="Selecting this will also select other instances of the same test">
                    {duplicateCount}x Same Test
                  </span>
                )}
              </div>
              <small style={{ color: paramCount > 0 ? '#28a745' : '#dc3545' }}>
                {paramCount} parameter{paramCount !== 1 ? 's' : ''}
                {hasResults && ' • Has results'}
                {paramCount === 0 && ' • ⚠️ No params loaded'}
                {!isApproved && ' • Cannot print until approved'}
                {hasDuplicates && ' • Linked with same test instances'}
              </small>
            </label>
          </div>
        );
      })}
    </div>

    {selectedTests.length === 0 && (
      <div className="alert alert-warning mt-3">
        Please select at least one approved test to print
      </div>
    )}
    
    {/* ✅ Info about duplicate tests */}
    {(currentTests || []).some((t, i, arr) => {
      const labItemTestId = String(t.lab_item_test_id || t.test_id || '');
      return arr.filter(x => String(x.lab_item_test_id || x.test_id || '') === labItemTestId).length > 1;
    }) && (
      <div className="alert alert-info mt-3" style={{ fontSize: '0.9em' }}>
        <i className="ri-information-line me-1"></i>
        <strong>Note:</strong> Tests with the same name are linked. Selecting one will auto-select all instances of that test.
      </div>
    )}
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowReportModal(false)}>
      Cancel
    </Button>
    
    <Button 
      variant="success" 
      onClick={handleSendWhatsApp}
      disabled={selectedTests.length === 0}
      style={{ display: 'flex', alignItems: 'center', gap: 6 }}
    >
      <i className="ri-whatsapp-line" style={{ fontSize: 18 }}></i>
      Send Notification
    </Button>
    
    <Button 
      variant="info" 
      onClick={handleSendLabPdfWhatsApp}
      disabled={selectedTests.length === 0}
      style={{ display: 'flex', alignItems: 'center', gap: 6 }}
    >
      <i className="ri-file-pdf-line" style={{ fontSize: 18 }}></i>
      Send PDF Report
    </Button>
    
    <Button 
      variant="primary" 
      onClick={handlePrintClick}
      disabled={selectedTests.length === 0}
    >
      <i className="ri-printer-line me-2"></i>
      Print Selected ({selectedTests.length})
    </Button>
  </Modal.Footer>
</Modal>


{/* Payment Modal - Add this before the closing </div> */}
{showPaymentModal && selectedPaymentPatient && (
    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9999 }}>
        <div className="modal-dialog modal-lg">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">Add Payment - {selectedPaymentPatient.lab_reg_name}</h5>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={() => setShowPaymentModal(false)}
                    ></button>
                </div>

                <div className="modal-body">
                    {/* Patient Info */}
                    <div className="alert alert-info mb-3">
                        <div className="row">
                            <div className="col-md-6">
                                <strong>UHID:</strong> {selectedPaymentPatient.lab_reg_uhid}<br />
                                <strong>Patient:</strong> {selectedPaymentPatient.lab_reg_name}
                            </div>
                            <div className="col-md-6 text-end">
                                <strong>Total:</strong> ₹{Number(selectedPaymentPatient.lab_final_amt || 0).toFixed(2)}<br />
                                <strong>Paid:</strong> ₹{Number(selectedPaymentPatient.lab_paid || 0).toFixed(2)}<br />
                                <strong className="text-danger">Due:</strong> ₹{Number(selectedPaymentPatient.lab_due || 0).toFixed(2)}
                            </div>
                        </div>
                    </div>

                    {/* Payment Form */}
                    <div className="row">
                       {/* Replace the Payment Mode dropdown in the payment modal */}
<div className="col-md-6 mb-3">
    <label className="form-label">Payment Mode *</label>
    <select
        className="form-control"
        value={paymentMode}
        onChange={(e) => setPaymentMode(e.target.value)}
        style={{
            color: paymentMode === '' ? '#999' : '#000'
        }}
    >
        <option value="" disabled>-- Select Payment Mode --</option>
        <option value="Cash">Cash</option>
        <option value="Card">Card</option>
        <option value="Online">Online</option>
    </select>
    {paymentMode === '' && (
        <small className="text-danger">Please select a payment mode</small>
    )}
</div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label">Payment Amount *</label>
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Enter amount"
                                value={paymentAmount}
                                onChange={(e) => setPaymentAmount(e.target.value)}
                                max={selectedPaymentPatient.lab_due}
                                step="0.01"
                            />
                            <small className="text-muted">
                                Maximum: ₹{Number(selectedPaymentPatient.lab_due || 0).toFixed(2)}
                            </small>
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label">Received By *</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter name"
                                value={paymentReceivedBy}
                                readOnly
                                style={{ backgroundColor: '#e9ecef' }}
                            />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label">Remarks (Optional)</label>
                            <textarea
                                className="form-control"
                                rows="2"
                                placeholder="Optional remarks"
                                value={paymentRemarks}
                                onChange={(e) => setPaymentRemarks(e.target.value)}
                            ></textarea>
                        </div>
                    </div>

                    {/* Payment History */}
                    {paymentHistory.length > 0 && (
                        <>
                            <hr />
                            <h6 className="mb-3">Payment History</h6>
                            <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                <table className="table table-sm table-bordered">
                                    <thead className="table-light">
                                        <tr>
                                            <th style={{width: '40px'}}>Sl.</th>
                                            <th>Date & Time</th>
                                            <th>Mode</th>
                                            <th className="text-end">Amount</th>
                                            <th>Received By</th>
                                            {(ldata?.type === 'admin' || ldata?.user_type === 'Admin') && (
                                                <th style={{width: '80px'}}>Action</th>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {paymentHistory.map((payment, index) => (
                                            <tr key={payment.payment_id}>
                                                <td>{index + 1}</td>
                                                <td>{new Date(payment.payment_datetime).toLocaleString()}</td>
                                                <td>
                                                    <span className={`badge ${
                                                        payment.payment_mode === 'Cash' ? 'bg-success' :
                                                        payment.payment_mode === 'Card' ? 'bg-primary' :
                                                        'bg-info'
                                                    }`}>
                                                        {payment.payment_mode}
                                                    </span>
                                                </td>
                                                <td className="text-end">₹{parseFloat(payment.payment_amount).toFixed(2)}</td>
                                                <td>{payment.payment_received_by}</td>
                                                {(ldata?.type === 'admin' || ldata?.user_type === 'Admin') && (
                                                    <td>
                                                        <button
                                                            className="btn btn-sm btn-danger"
                                                            onClick={() => handleDeletePayment(payment.payment_id)}
                                                        >
                                                            <i className="ri-delete-bin-line"></i>
                                                        </button>
                                                    </td>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot className="table-light">
                                        <tr>
                                            <th colSpan="3" className="text-end">Total Paid:</th>
                                            <th className="text-end">
                                                ₹{paymentHistory.reduce((sum, p) => sum + parseFloat(p.payment_amount), 0).toFixed(2)}
                                            </th>
                                            <th colSpan={(ldata?.type === 'admin' || ldata?.user_type === 'Admin') ? "2" : "1"}></th>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </>
                    )}
                </div>

                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setShowPaymentModal(false)}
                    >
                        Cancel
                    </button>
                    {/* ✅ NEW: Refund Button - Only show if paid amount > 0 */}
  {parseFloat(selectedPaymentPatient?.lab_paid || 0) > 0 && (
    <button
      type="button"
      className="btn btn-danger"
      onClick={openRefundModal}>
      <i className="ri-refund-2-line me-1"></i>
      Refund
    </button>
  )}
                    
                    
                    <button
                        type="button"
                        className="btn btn-success"
                        onClick={handleAddPayment}
                    >
                        <i className="ri-check-line me-1"></i>
                        Add Payment
                    </button>
                </div>
            </div>
        </div>
    </div>
)}


{/* Refund Modal */}
{showRefundModal && selectedPaymentPatient && (
  <div
    className="modal fade show d-block"
    tabIndex="-1"
    style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 10000 }}
  >
    <div className="modal-dialog modal-lg">
      <div className="modal-content">
        <div className="modal-header bg-danger text-white">
          <h5 className="modal-title">
            <i className="ri-refund-2-line me-2"></i>
            Process Refund - {selectedPaymentPatient.lab_reg_name}
          </h5>
          <button
            type="button"
            className="btn-close btn-close-white"
            onClick={() => setShowRefundModal(false)}
          ></button>
        </div>

        <div className="modal-body">
          {/* Patient Info */}
          <div className="alert alert-warning mb-3">
            <div className="row">
              <div className="col-md-6">
                <strong>UHID:</strong> {selectedPaymentPatient.lab_reg_uhid}<br />
                <strong>Patient:</strong> {selectedPaymentPatient.lab_reg_name}
              </div>
              <div className="col-md-6 text-end">
                <strong>Total:</strong> ₹{Number(selectedPaymentPatient.lab_final_amt || 0).toFixed(2)}<br />
                <strong className="text-success">Paid:</strong> ₹{Number(selectedPaymentPatient.lab_paid || 0).toFixed(2)}<br />
                <strong>Due:</strong> ₹{Number(selectedPaymentPatient.lab_due || 0).toFixed(2)}
              </div>
            </div>
          </div>

          {/* Refund Form */}
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Refund Mode *</label>
              <select
                className="form-control"
                value={refundMode}
                onChange={(e) => setRefundMode(e.target.value)}
                style={{ color: refundMode === '' ? '#999' : '#000' }}
              >
                <option value="" disabled>-- Select Refund Mode --</option>
                <option value="Cash">Cash</option>
                <option value="Card">Card</option>
                <option value="Online">Online</option>
                <option value="Bank Transfer">Bank Transfer</option>
              </select>
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Refund Amount *</label>
              <input
                type="number"
                className="form-control"
                placeholder="Enter amount"
                value={refundAmount}
                onChange={(e) => setRefundAmount(e.target.value)}
                max={selectedPaymentPatient.lab_paid}
                step="0.01"
              />
              <small className="text-muted">
                Maximum: ₹{Number(selectedPaymentPatient.lab_paid || 0).toFixed(2)}
              </small>
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Refunded By *</label>
              <input
                type="text"
                className="form-control"
                value={refundedBy}
                readOnly
                style={{ backgroundColor: '#e9ecef' }}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Remarks * (Mandatory)</label>
              <textarea
                className="form-control"
                rows="2"
                placeholder="Reason for refund"
                value={refundRemarks}
                onChange={(e) => setRefundRemarks(e.target.value)}
              ></textarea>
            </div>
          </div>

          {/* Refund History */}
          {refundHistory.length > 0 && (
            <>
              <hr />
              <h6 className="mb-3">Refund History</h6>
              <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                <table className="table table-sm table-bordered">
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: '40px' }}>Sl.</th>
                      <th>Date & Time</th>
                      <th>Mode</th>
                      <th className="text-end">Amount</th>
                      <th>Refunded By</th>
                      <th>Remarks</th>
                      {(ldata?.type === 'admin' || ldata?.user_type === 'Admin') && (
                        <th style={{ width: '80px' }}>Action</th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {refundHistory.map((refund, index) => (
                      <tr key={refund.refund_id}>
                        <td>{index + 1}</td>
                        <td>{new Date(refund.refund_datetime).toLocaleString()}</td>
                        <td>
                          <span className="badge bg-danger">{refund.refund_mode}</span>
                        </td>
                        <td className="text-end">₹{parseFloat(refund.refund_amount).toFixed(2)}</td>
                        <td>{refund.refunded_by}</td>
                        <td>{refund.refund_remarks || '-'}</td>
                        {(ldata?.type === 'admin' || ldata?.user_type === 'Admin') && (
                          <td>
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() => handleDeleteRefund(refund.refund_id)}
                              title="Delete refund"
                            >
                              <i className="ri-delete-bin-line"></i>
                            </button>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                  <tfoot className="table-light">
                    <tr>
                      <th colSpan="3" className="text-end">Total Refunded:</th>
                      <th className="text-end">
                        ₹{refundHistory.reduce((sum, r) => sum + parseFloat(r.refund_amount), 0).toFixed(2)}
                      </th>
                      <th colSpan={(ldata?.type === 'admin' || ldata?.user_type === 'Admin') ? "3" : "2"}></th>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </>
          )}
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setShowRefundModal(false)}
            disabled={refundProcessing}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleProcessRefund}
            disabled={refundProcessing}
          >
            {refundProcessing ? (
              <>
                <span className="spinner-border spinner-border-sm me-1"></span>
                Processing...
              </>
            ) : (
              <>
                <i className="ri-refund-2-line me-1"></i>
                Process Refund
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default LabRegistrations;
